export default {
  // the app loader on the first load (#223)
  app_loader: {
    title: 'GreenMapper wordt klaargezet',
    steps: {
      connect: 'Verbinden met GreenMapper',
      account: 'Je account ophalen',
      places: 'Gebieden op de kaart zetten',
      communities: 'Communities laden',
      news: 'Nieuws en instellingen',
      settings: 'Alles klaarzetten',
      ready: 'Klaar!'
    },
    slow: 'Dit duurt langer dan normaal.',
    retry: 'Opnieuw proberen',
    open_anyway: 'Toch openen'
  },
  // a login link from an e-mail and an unknown address (#340: on the app loader's card)
  redirect: {
    failed: 'Deze inloglink werkt niet meer',
    title: 'We loggen je in…',
    step: 'Inloggen'
  },
  not_found: {
    checking: 'We kijken of de pagina bestaat…',
    checking_sub: 'De pagina zoeken',
    title: '404: pagina niet gevonden',
    text: 'Op dit adres staat niets.',
    home: 'Terug naar de startpagina'
  },
  notice: {
    progress: '{done} van {total} plekken gemarkeerd',
    places_left: 'Nog 1 plek te markeren | Nog {left} plekken te markeren',
    participation_hint: 'Nog een paar stappen om je plekken af te ronden.',
    participation_unfinished: 'Je deelname is nog niet afgerond'
  },
  home_tiles: {
    areas_count: '{count} gebied | {count} gebieden',
    communities_count: '{count} community | {count} communities',
    budget_line: '{amount} budget · {pct}% toegezegd',
    subscribers: '{count} abonnee | {count} abonnees',
    notifications: 'Meldingen',
    unread: '{count} ongelezen',
    all_read: 'Alles gelezen',
    no_messages: 'Nog geen berichten',
    pledged: 'toegezegd',
    no_budget: 'Nog geen natuurbudget',
    no_areas: 'Nog geen gebieden. Markeer plekken die je belangrijk vindt op de kaart.',
    no_communities: 'Je volgt nog geen community.',
    browse_map: 'Bekijk de kaart',
    greet_morning: 'Goedemorgen, {name}',
    greet_afternoon: 'Goedemiddag, {name}',
    greet_evening: 'Goedenavond, {name}',
    per_year: 'per jaar',
    new: 'nieuw'
  },
  // the create-community wizard's texts (#126)
  wizard_versions: {
    // #321: the find screen's list / map switch (phones) and the larger map (wider screens)
    search_short: 'Zoeken',
    view_list: 'Lijst',
    view_map: 'Kaart',
    map_larger: 'Kaart groter',
    map_smaller: 'Lijst weer tonen',
    cancel: 'Annuleren',
    question: 'Welk gebied beheer je?',
    results: 'Resultaten',
    legend: 'Filters',
    filters_open: 'Filters openen',
    filters_collapse: 'Filters inklappen',
    new_community: 'Nieuwe community',
    back_to_results: 'Terug naar de lijst',
    col_name: 'Naam',
    my_location: 'Mijn locatie',
    locate: 'Gebieden bij mijn locatie',
    locate_failed: 'Je locatie kon niet worden bepaald. Zoek op een plaats.',
    locate_denied: 'Je hebt je locatie niet gedeeld. Sta het toe in de browser, of zoek op een plaats.',
    locate_insecure: 'Je locatie werkt alleen via een beveiligde verbinding (https). Zoek op een plaats.',
    loading_results: 'Gebieden laden…',
    lists_n: '{count} lijsten',
    col_type: 'Soort',
    col_country: 'Land',
    col_size: 'Oppervlakte',
    position: 'Ligging',
    loading_title: 'De kaart wordt klaargezet',
    load_lists: 'De lijsten',
    load_areas: 'De eerste gebieden',
    load_map: '{list} op de kaart',
    load_index: 'De kaart opbouwen',
    areas_here: '{count} gebieden hier',
    choose_area_here: 'Kies een van de {count} gebieden hier',
    map_updating: 'Kaart bijwerken…',
    map_areas_loading: 'Gebieden laden…',
    map_loading: 'De kaart laadt nog alle gebieden…',
    sheet: 'Lijst groter of kleiner',
    count_areas: 'geen gebieden | 1 gebied | {count} gebieden',
    // waits (the user, 11 Oct): a long one, no connection, a failure; "Try again" asks the same again
    slow: 'Dit duurt langer dan normaal.',
    try_again: 'Opnieuw proberen',
    offline: 'Geen verbinding met de server. Opnieuw verbinden…',
    reconnect: 'Nu proberen',
    lists_failed: 'De lijsten konden niet worden geladen.',
    places_failed: 'Plaatsen zoeken is mislukt.',
    sending: 'Je community wordt ingediend…',
    count_failed: 'De fans konden niet worden geteld.'
  },
  messages: {
    pictures_missing: 'Een foto van deze discussie kon niet worden geladen: die valt weg als je opslaat.',
    // account_created: 'Please check your email to verify your registration. This sometimes can take up to 10 minutes. Please check the spam folder if the email has not been received.',
    // password_forgot: 'Please check your email to reset your password.',
    // verification_success: 'Your e-mail has been verified. You can now login.',
    // verification_failed: 'Verification has failed.',
    // password_recover_success: 'Your password has been reset. You can now login with the new password.',
    // logout_confirmation: 'Are you sure you want to log out?',
    // confirm: 'Confirm',
    // update_available: 'A new update is available. Click on ok to reload the page.',
    // account_signed_out: 'You have been signed out',
    // account_updated: 'Account succesfully updated'
    account_created: 'Account succesvol aangemaakt',
    password_forgot: 'Controlleer je e-mail voor het opnieuw instellen van je wachtwoord.',
    account_signed_out: 'Je bent succesvol uitgelogd',
    logout_failed: 'Uitloggen is niet gelukt. Probeer het nog eens.',
    account_updated: 'Account succesvol aangepast',
    verification_success: 'Je e-mail is geverifieerd. Je kunt nu inloggen.',
    verification_failed: 'Verificatie is mislukt.',
    password_recover_success: 'Je wachtwoord is opnieuw ingesteld. Je kunt nu inloggen met je nieuwe wachtwoord.',
    password_reset_link_invalid: 'Deze link werkt niet meer. Een link om je wachtwoord opnieuw in te stellen werkt één keer en 24 uur lang. Vraag een nieuwe aan met \'Wachtwoord vergeten?\' op het inlogscherm.',
    password_reset_failed: 'Je wachtwoord kon niet worden gewijzigd. Probeer het opnieuw.',
    password_reset_to_login: 'Naar het inlogscherm',
    logout_confirmation: 'Weet je zeker dat je uit wilt loggen?',
    login_confirmation: 'Je bent succesvol ingelogd. Welkom terug!',
    login_failed: 'E-mail en wachtwoord combinatie niet bekend',
    confirm: 'Bevestig',
    update_available: 'Een nieuwe update is beschikbaar. Klik op ok om de pagina te verversen.',
    update_ready: 'Er staat een nieuwe versie van de app klaar.',
    update_reload: 'Vernieuwen',
    url_copied_to_clipboard: 'De kaart url is gecopieerd naar het klembord',
    add_area_account_required: 'Om een gebied toe te kunnen voegen, heb je een account nodig.',
    area_deleted: 'Het gebied is verwijderd',
    area_updated: 'Het gebied is aangepast',
    unsubscribed: 'Je bent niet langer lid van deze community',
    subscribed: 'Je bent nu onderdeel van deze community',
    thread_created: 'Er is een nieuwe discussie gestart',
    thread_updated: 'De discussie is aangepast',
    comment_created: 'Je hebt content geplaatst',
    comment_reported: 'Deze content is gevlagd voor moderatie',
    comment_unreported: 'Deze content is vrijgegeven na moderatie',
    comment_deleted: 'Deze content is verwijderd',
    community_updated: 'Deze content is aangepast',
    RMS_send: 'Een moderator verzoek is verstuurd',
    poll_created: 'Poll aangemaakt',
    polis_created: 'Polis aangemaakt',
    meeting_created: 'Meeting aangemaakt',
    meeting_invite_accepted: 'Je hebt de uitnodiging geaccepteerd',
    meeting_invite_declined: 'Je hebt de uitnodiging geweigerd',
    pledge_funding_completed: 'Doneren succesvol afgerond',
    pledge_added: 'Bedankt voor je toezegging van € ',
    pledge_rejected: 'Dank voor je uitleg',
    pledge_created: 'Toezegging aangemaakt',
    pledge_updated: 'Toezegging bijgewerkt',
    pledge_deleted: 'De toezegging is verwijderd',
    pledge_pictures_missing: 'Een foto van deze toezegging kon niet worden geladen: hij valt weg als je opslaat.',
    treasure_created: 'Treasure toegevoegd'
  },
  errors: {
    general_error: 'Er is een fout opgetreden. Probeer het nogmaals.',
    not_found: 'Sorry, hier is niks...',
    network: 'Netwerk fout. Controleer je internet verbinding',
    // fields: 'Please correct the input fields',
    required: 'Verplicht veld',
    register: {
      password_length: 'De minimale lengte van het wachtwoord is {length} karakters.',
      password_match: 'De wachtwoorden komen niet overeen.',
      email_valid: 'Een geldig e-mail adres is vereist',
      name_length: 'Schermnaam lengte moet tussen {minLength} en {maxLength} karakters zijn',
      organization_length: 'Organisatienaam lengte moet tussen {minLength} en {maxLength} karakters zijn'
    }
  },
  buttons: {
    fullscreen: 'Volledig scherm',
    fullscreen_exit: 'Volledig scherm sluiten',
    pledge: 'Toezeggen',
    ok: 'Ok',
    submit: 'Verstuur',
    logout: 'Log uit',
    cancel: 'Annuleren',
    login: 'Login',
    register: 'Registreer',
    // go_back: 'Go back',
    send: 'Verstuur',
    reSend: 'Verstuur opnieuw',
    close: 'Sluit',
    previous: 'Vorige',
    save: 'Opslaan',
    create: 'Aanmaken',
    update: 'Update',
    delete: 'Verwijder',
    subscribe: 'Aanmelden',
    unsubscribe: 'Afmelden',
    next: 'Volgende',
    continue: 'Verder',
    back: 'Terug',
    add: 'Voeg toe',
    edit: 'Aanpassen',
    reply: 'Antwoorden',
    report: 'Melden',
    unreport: 'Melden annuleren',
    goto_authenticate: 'Naar login',
    stop: 'Stop',
    pauze: 'Pauzeren',
    continue_register: 'Verder met registratie',
    continue_participation: 'Doorgaan met participatie',
    mark_places: 'Plekken markeren',
    become_moderator: 'Moderator worden',
    add_image: 'Plaatje toevoegen',
    accept: 'Accepteren',
    decline: 'Weigeren',
    reset: 'Reset',
    discard: 'Verwerpen'
  },
  headers: {
    area_owners: 'Gebiedseigenaren',
    admin_home: 'Home',
    fans: 'Fans',
    maintenance: 'Onderhoud',
    login: 'Login',
    register: 'Registreren',
    password_forgot: 'Nieuw wachtwoord aanvragen',
    password_recover: 'Wachtwoord herstellen',
    administrator: 'Administrator',
    navigation: 'Navigatie',
    my_overview: 'Mijn overzicht',
    overview: 'Overzicht',
    users: 'Users',
    communities: 'Communities'
  },
  activities: {
    act_cycl: {
      title: 'Fietsen'
    },
    act_walk: {
      title: 'Wandelen of hardlopen'
    },
    act_tour: {
      title: 'Rondrijden met auto of motor'
    },
    act_natu: {
      title: 'Natuur observeren'
    },
    act_water: {
      title: 'Watersport'
    },
    act_play: {
      title: 'Spelen of zitten'
    },
    act_wintr: {
      title: 'Wintersport'
    },
    act_mount: {
      title: 'Bergsport'
    }
  },
  labels: {
    upvote: 'Eens',
    // a post's reply started from a comment (#340): the bar above the reply
    replying_to: 'Antwoord op',
    replying_to_cancel: 'Niet als antwoord op {name}',
    // the photo picker (UiPhotoPicker, #469)
    photo_add: 'Foto toevoegen',
    photos_add: 'Foto\'s toevoegen',
    photos_add_short: 'Toevoegen',
    photos_drop: 'tik, of sleep ze hierheen (.jpg)',
    photos_jpg_only: 'Alleen .jpg-foto\'s kunnen worden toegevoegd.',
    downvote: 'Oneens',
    // a wizard's step (UiWizard, #355)
    step_of: 'Stap {step} van {total}',
    rows_of: '{shown} van {total}',
    show_more: 'Toon er {n} meer',
    account_required: 'Account noodzakelijk',
    read_more: 'lees verder',
    'area_create_button': 'Opslaan',
    'area_update_button': 'Opslaan',
    'area_created_succes': 'Gebied succesvol aangemaakt',
    'area_updated_succes': 'Gebied succesvol aangepast',
    'community_created_succes': 'Community succesvol aangemaakt',
    agree_disclaimer: 'Ik ga akkoord met deze voorwaarden',
    my_account: 'Mijn account',
    register: 'Maak account aan',
    logout: 'Loguit',
    login: 'Login',
    email: 'E-mailadres',
    name: 'Schermnaam',
    companyName: 'Bedrijfsnaam',
    organization: 'Organisatienaam',
    sector: 'Sector',
    address: 'Adres',
    address_search: 'Woonplek',
    // zipcodeCompany: 'Zipcode headquarter',
    website: 'Web pagina',
    city: 'Woonplaats',
    // cityCompany: 'City headquarter',
    age: 'Leeftijdscategorie',
    education: 'Opleiding',
    gender: 'Geslacht',
    type: 'Type',
    password: 'Wachtwoord',
    repeat_password: 'Herhaal wachtwoord',
    remember_me: 'Onthoud mij',
    show_password: 'Wachtwoord tonen',
    hide_password: 'Wachtwoord verbergen',
    clear_address: 'Ander adres kiezen',
    password_forgot: 'Wachtwoord vergeten?',
    home: 'Thuis',
    here: 'hier',
    neighbourhood: 'buurt',
    'living-area': 'regio',
    country: 'land',
    worldwide: 'wereldwijd',
    share_this_area: 'Deel dit gebied',
    share_this_community: 'Deel deze community',
    subscribed: 'Geabonneerd',
    reply: 'Antwoorden',
    comment: 'Commentaar',
    finish: 'Beëindigen',
    readmore: 'lees meer',
    search: 'zoek',
    created_on: 'aangemaakt op',
    dear: 'Beste',
    karma: 'Karma'
  },
  pages: {
    free_draw: {
      title: 'Teken je gebied',
      tools: 'Tekengereedschap',
      mode_edit: 'Punten bewerken',
      mode_move: 'Vorm verplaatsen',
      mode_rotate: 'Vorm draaien',
      undo: 'Ongedaan maken',
      more_tools: 'Meer tools',
      redo: 'Opnieuw',
      delete_points: 'Punten verwijderen',
      import: 'Bestand importeren (GeoJSON of KML)',
      start_over: 'Opnieuw beginnen',
      start_over_title: 'Opnieuw beginnen?',
      start_over_text: 'Dit verwijdert de vorm. Je kunt het nog ongedaan maken.',
      layer_map: 'Kaart',
      layer_satellite: 'Satelliet',
      my_location: 'Mijn locatie',
      zoom_to_shape: 'Inzoomen op vorm',
      search_place: 'Zoek een plaats',
      search_place_placeholder: 'Plaats, dan Enter',
      warn_point_outside: 'Je tekening bevat de locatie van {name} niet.',
      warn_size: 'Je tekening ({drawn}) wijkt sterk af van de opgegeven grootte ({reported}).',
      warn_huge: 'Je gebied is erg groot: {size}. Klopt dat?',
      more: 'Meer',
      hint_closed_phone: 'Vorm gesloten. Sleep een punt om de grens bij te werken; houd een punt vast om het weg te halen.',
      hint_many_phone: 'Vorm met {count} punten: ze worden verspreid getoond. Zoom in voor meer punten om te slepen.',
      legend_title: 'Ook handig',
      legend_last: 'Klik op het laatste punt om het weg te halen',
      legend_undo: 'Ctrl+Z maakt ongedaan, Ctrl+Y doet het opnieuw',
      legend_import: 'Een grens importeren kan ook (GeoJSON of KML)',
      reported: 'Opgegeven: {size}',
      your_drawing: 'jouw tekening: {size}',
      area: 'Oppervlakte',
      border: 'Grens',
      close_shape: 'Vorm sluiten',
      close_shape_tip: 'Of klik op het eerste punt, of druk op Esc',
      points_count: 'geen punten | 1 punt | {count} punten',
      hint_tap: 'Klik op de kaart om punten langs de grens te zetten. Klik op het eerste punt om de vorm te sluiten.',
      hint_edit: 'Sleep een punt om het te verplaatsen. Sleep een klein bolletje op een lijn om een punt toe te voegen. Rechtsklik op een punt om het te verwijderen.',
      hint_edit_many: 'Deze vorm heeft veel punten: ze worden verspreid getoond, meer naarmate je inzoomt. Sleep een punt om het te verplaatsen. Sleep een klein bolletje op een lijn om een punt toe te voegen. Rechtsklik op een punt om het te verwijderen.',
      hint_delete: 'Tik op een punt om het te verwijderen. Tik nogmaals op het verwijdergereedschap om te stoppen.',
      hint_delete_click: 'Klik op een punt om het te verwijderen. Klik nogmaals op het verwijdergereedschap om te stoppen.',
      hint_move: 'Sleep de vorm om hem te verplaatsen.',
      hint_rotate: 'Sleep aan een hoekpunt om de vorm te draaien.',
      check_points: 'Gesloten vorm met minstens {min} punten',
      check_crossing: 'Geen kruisende lijnen',
      check_range: 'Niet over de datumgrens (180°)',
      check_area_min: 'Minstens {minArea}',
      check_area_max: 'Hoogstens {maxArea}',
      check_points_max: 'Hoogstens {max} punten',
      problem_points: 'Sluit de vorm met minstens {min} punten.',
      problem_crossing: 'Lijnen kruisen elkaar. Verplaats een punt zodat ze niet meer kruisen.',
      problem_range: 'De vorm gaat over de datumgrens (180°). Teken hem aan één kant van die lijn.',
      problem_area_min: 'Het gebied is te klein: minstens {minArea}.',
      problem_area_max: 'Het gebied is te groot: hoogstens {maxArea}.',
      problem_points_max: 'De vorm heeft te veel punten: hoogstens {max}.',
      rejected_cross: 'Lijnen mogen niet kruisen',
      rejected_min_points: 'Minstens {min} punten',
      location_unavailable: 'Je locatie is niet beschikbaar.',
      imported: 'Vorm met {count} punten geïmporteerd. Controleer hem en pas aan waar nodig.',
      import_errors: {
        unknown_format: 'Dit bestand is geen GeoJSON of KML.',
        no_polygon: 'Het bestand bevat geen gebied (polygoon).',
        multiple: 'Het bestand bevat meer dan één gebied. Gebruik een bestand met één gebied.',
        holes: 'Het gebied heeft gaten. Gebruik een gebied zonder gaten.',
        invalid: 'Het gebied in dit bestand is niet geldig.'
      }
    },
    owner_community_new: {
      // #197: the boundary lies on (almost) the same area as an existing community
      overlap: {
        warning: 'Er is al een community op (bijna) hetzelfde gebied: {title}. Je kunt er toch een maken.',
        // another owner's community before its first approval: its name is not shown (#96)
        unnamed: 'een community die op goedkeuring wacht'
      },
      // #198: after drawing, the list area the drawing matches
      suggest: {
        title_used: 'Je gebied',
        locked_size: 'Officiële grens · {size}',
        locked_hint: 'Je gebruikt de officiële grens. Zelf tekenen? Kies Ongedaan maken.',
        checking: 'Controleren…',
        choose_first: 'Kies eerst: de officiële grens of je eigen tekening',
        question: 'Bedoel je dit gebied?',
        previous: 'Vorige',
        next: 'Volgende',
        count: '{at} van {of}',
        use_official: 'Officiële grens gebruiken',
        link: 'Koppel mijn tekening',
        keep: 'Mijn tekening houden',
        link_note: 'Dit gebied heeft geen grens in de lijst: je tekening wordt de grens, de naam en gegevens komen uit de lijst. Andere eigenaren kunnen het daarna niet meer kiezen.',
        used: 'Officiële grens van {name} gebruikt',
        linked: 'Je tekening is gekoppeld aan {name}',
        kept: 'Je houdt je eigen tekening',
        undo: 'Ongedaan maken',
        show_again: 'Toch bekijken'
      },
      title_draw: 'Teken je gebied',
      title_draw_boundary: 'Teken de grens',
      title_details: 'Geef je community een naam',
      title_fans: 'Wie telt als fan',
      title_fans_named: 'Wie wordt fan van {name}?',
      drawn_tag: 'Zelf getekend',
      continue_short: 'Verder',
      continue: 'Verder naar naam en beschrijving',
      continue_fans: 'Verder naar wie telt als fan',
      name: 'Naam van de community',
      name_required: 'Geef je community een naam.',
      description: 'Beschrijving',
      description_hint: 'Wat is dit gebied en waar gaat de community over?',
      description_required: 'Beschrijf het gebied en de community.',
      submitted: '{name} is ingediend ter controle',
      // the last step: the community as its page will show it (#96)
      review: {
        fans_count: '{n} fan | {n} fans',
        fans_few: 'minder dan {n} fans',
        more: 'meer',
        submit: 'Indienen ter controle',
        confirm_title: 'Community indienen?',
        confirm_text: 'Greenmapper controleert {name} eerst. Na goedkeuring krijgt je community {fans}. Naam en beschrijving kun je daarna nog aanpassen.',
        confirm_plain: 'Greenmapper controleert je community eerst. Naam en beschrijving kun je daarna nog aanpassen.',
        confirm_back: 'Nog even kijken',
        confirm_submit: 'Indienen'
      },
      steps: {
        area: 'Gebied',
        fans: 'Fans',
        name: 'Naam'
      },
      exit: 'Stoppen',
      exit_title: 'Stoppen met deze community maken?',
      exit_text: 'Wat je hebt gekozen, getekend of getypt wordt niet bewaard.',
      exit_keep: 'Doorgaan',
      exit_confirm: 'Stoppen',
      back: 'Terug',
      method: {
        free_title: 'Zelf tekenen',
        free_text: 'Teken de grens van je gebied op de kaart, of importeer een GeoJSON- of KML-bestand.'
      },
      find: {
        clear_filters: 'Wis filters',
        without_list: 'Zonder {list}',
        with_list: 'Met {list}',
        filters: 'Filters',
        clear_all: 'Wis alles',
        close: 'Sluiten',
        lists_title: 'Lijsten',
        size: 'Oppervlakte',
        size_any: 'Alle groottes',
        size_up_to: 'Tot {max} ha',
        size_from: 'Vanaf {min} ha',
        size_between: '{min}–{max} ha',
        place_title: 'Plaats',
        clear_place: 'Plaats weghalen',
        place_remove: 'Weghalen',
        countries_all: 'Toon alle {count} landen',
        countries_less: 'Minder landen',
        show_n: 'Toon 1 gebied | Toon {count} gebieden',
        places_none_in: 'Geen plaats “{query}” in {country}',
        around_chip: 'Rond {place}',
        none_near_named: 'Geen gebied met “{query}” bij {place}.',
        radius: 'Straal',
        radius_caption: 'Binnen een afstand van',
        other_places: 'Andere plaatsen met deze naam',
        near_action: 'Gebieden in de buurt',
        show_all: 'Toon het gebied met “{query}” | Toon alle {count} gebieden met “{query}”',
        country_search: 'Zoek een land',
        country_any: 'Alle landen',
        country_none: 'Geen land gevonden',
        none_named: 'Geen gebied met de naam “{query}”',
        show_all_more: 'Toon alle gebieden met “{query}” ({count}+)',
        places_none: 'Geen plaats gevonden',
        places_searching: 'Plaatsen zoeken…',
        places_failed: 'Plaatsen zoeken lukt nu niet',
        availability: 'Beschikbaarheid',
        count_more_short: '{count}+',
        refine: 'Maak je zoekopdracht preciezer om de rest te zien.',
        near_title: 'Gebieden rond {place} (binnen {km} km)',
        places_group: 'Plaatsen',
        areas_group: 'Gebieden',
        place_kinds: {
          city: 'Stad',
          town: 'Plaats',
          village: 'Dorp',
          hamlet: 'Gehucht',
          suburb: 'Wijk',
          municipality: 'Gemeente',
          county: 'Regio',
          state: 'Provincie',
          country: 'Land',
          island: 'Eiland',
          nature_reserve: 'Natuurgebied',
          national_park: 'Nationaal park',
          protected_area: 'Beschermd gebied',
          lake: 'Meer',
          peak: 'Top',
          forest: 'Bos',
          wood: 'Bos',
          heath: 'Heide',
          moor: 'Veen',
          wetland: 'Moeras'
        },
        title: 'Zoek je gebied',
        search: 'Zoek een gebied of plaats',
        country: 'Land',
        all: 'Alle',
        available: 'Vrij',
        taken: 'Bezet',
        count: 'geen gebieden | 1 gebied | {count} gebieden',
        failed: 'Zoeken is mislukt.',
        place_failed: 'Het zoeken naar plaatsen werkt nu niet. Zoeken op naam werkt wel.',
        no_places: 'Geen plaats gevonden voor “{query}”.',
        none_near: 'Geen gebieden uit de lijsten bij {place}.',
        none_filters: 'Geen gebieden met deze filters.',
        none_taken: 'Geen gebieden in gebruik.',
        badge_official: 'Officieel',
        badge_partial: 'Kerngebied',
        badge_proxy: 'Benaderd',
        badge_draw: 'Zelf tekenen',
        // #196: the other lists the same area is in (one row per area group)
        also_in: 'Ook in {lists}',
        badge_in_use: 'In gebruik',
        badge_disabled: 'Niet beschikbaar',
        sources_short: {
          unesco: 'UNESCO',
          eea: 'EEA',
          wdpa: 'WDPA',
          osm: 'OSM',
          research: 'Onderzoek',
          national: 'Nationaal',
          arcgis: 'Kaartlaag',
          province: 'Provincie',
          other: 'Andere bron'
        },
        osm_credit: '© OpenStreetMap contributors'
      },
      // who counts as a fan (#96)
      fans: {
        what: 'Wie op Greenmapper een plek in je fanzone markeerde, wordt fan en krijgt je berichten.',
        what_close: 'Uitleg sluiten',
        what_open: 'Wat is een fan?',
        slider: 'Grootte van de fanzone',
        area_only: 'Alleen je gebied',
        area_only_short: 'Alleen gebied',
        recommended: 'Aanbevolen',
        wide: 'Ruim',
        back_to_recommended: 'Terug naar aanbevolen',
        fans_short: 'fans in de zone',
        legend_area: 'Je gebied',
        legend_zone: 'Fanzone',
        // what each line on the map is for: the same words under the legend on every step and screen width
        legend_area_explain: 'Getoond als community',
        legend_zone_explain: 'Bepaalt wie fan wordt',
        legend_start: 'Aanbevolen',
        zone_is_area: 'gelijk aan je gebied',
        load_failed: 'De fanzone kon niet worden geladen.',
        retry: 'Opnieuw',
        failed: 'Deze stand kon niet worden berekend. Kies een andere stand.',
        invalid: 'De fanzone werd niet geaccepteerd. Kies een andere stand en probeer het opnieuw.'
      },
      official: {
        not_listed_title: 'Staat je gebied er niet bij?',
        not_listed_text: 'Teken de grens dan zelf op de kaart.',
        choose_this: 'Kies dit gebied',
        title: 'Je gebied',
        retry: 'Opnieuw proberen',
        no_results: 'Geen gebied gevonden voor “{query}”.',
        badge_official: 'Officiële grens',
        badge_partial: 'Alleen kerngebied',
        badge_proxy: 'Benaderd gebied',
        badge_draw: 'Geen grens: jij tekent hem',
        reason_in_use: 'Al in gebruik',
        in_use_by: 'Al in gebruik door {title}',
        reason_disabled: 'Niet beschikbaar',
        boundary_from: 'Grens: {source}.',
        boundary_drawn: 'Grens door jou getekend',
        source_link_short: 'Pagina openen',
        fact_type: 'Type',
        fact_country: 'Land',
        fact_size: 'Grootte',
        fact_source: 'Bron',
        boundary_title: 'Grens',
        boundary_free_same: 'Dezelfde plek staat nog een keer in {list}; die grens is nog vrij.',
        boundary_not_changed: 'De grens is niet gewijzigd: dat duurde te lang.',
        boundary_free_elsewhere: 'Dezelfde plek staat ook in {list}; die grens is nog vrij.',
        choose_that: 'Kies die grens',
        boundary_list_in_use: '{list}: al in gebruik door {title}',
        boundary_list_unavailable: '{list}: niet beschikbaar',
        partial_note: 'Deze grens omvat alleen het kerngebied van {name}, niet het hele gebied.',
        proxy_note: 'Dit is het gebied waarnaar {name} is genoemd; de precieze grens is nog niet beschikbaar.',
        draw_note: 'De lijst heeft geen grens voor {name}. Jij tekent hem; de community houdt de naam en gegevens uit de lijst.',
        draw_boundary: 'Teken de grens',
        reported_size: 'opgegeven {size}',
        pick_hint: 'Kies een gebied uit de resultaten om het op de kaart te zien.',
        map: 'Kaart',
        satellite: 'Satelliet',
        reset_view: 'Hele gebied tonen',
        name_hint: 'Ingevuld vanuit de lijst; je kunt het aanpassen.',
        free_instead: 'Zelf tekenen',
        in_use_error: '{name} is net gekozen voor een andere community. De resultaten zijn bijgewerkt.',
        sources: {
          unesco: 'UNESCO',
          eea: 'Europees Milieuagentschap (EEA)',
          wdpa: 'Protected Planet (WDPA)',
          osm: 'OpenStreetMap',
          research: 'Onderzoeksdataset',
          national: 'Nationale open data',
          arcgis: 'Gepubliceerde kaartlaag',
          province: 'Natuurbeheerkaart van de provincie',
          other: 'Andere bron'
        }
      }
    },
    owner_register: {
      title: 'Registreer je organisatie als gebiedseigenaar',
      lead: 'Je kunt een community starten rond grond die je beheert. Eerst controleren we wie je bent.',
      what_happens: 'Wat er gebeurt na je registratie',
      step1_title: 'Maak je account aan',
      step1_text: 'Je krijgt meteen je eigenaarspagina.',
      step2_title: 'Wij verifiëren je organisatie',
      step2_text: 'Een Greenmapper-beheerder controleert je gegevens. Je eigenaarspagina toont het resultaat.',
      step3_title: 'Maak je communities',
      step3_text: 'Kies een officieel gebied of teken je eigen gebied.',
      banner: 'Na je registratie verifieert een Greenmapper-beheerder je organisatie. Tot die tijd zie je je eigenaarspagina, maar kun je nog geen communities maken.',
      stepper_account: 'Je account',
      stepper_organization: 'Je organisatie',
      your_name: 'Je naam',
      organization: 'Organisatie',
      organization_too_long: 'Gebruik maximaal {maxLength} tekens',
      organization_required: 'Vul de naam van je organisatie in',
      consent: 'Ik ga akkoord met de {link}.',
      privacy_statement: 'privacyverklaring voor landschapsorganisaties',
      consent_required: 'Ga akkoord met de privacyverklaring om verder te gaan.',
      submit: 'Eigenaarsaccount maken',
      already_registered: 'Al geregistreerd?',
      log_in: 'Inloggen',
      created: 'Je eigenaarsaccount is klaar.'
    },
    owner_dashboard: {
      create_community: 'Community maken',
      strip_pending: 'Wacht op verificatie.',
      strip_rejected: 'Je registratie is niet goedgekeurd.',
      strip_verified: 'Geverifieerd',
      text_pending: 'Je kunt je communities bekijken. Bewerken en maken kan zodra een Greenmapper-beheerder je organisatie heeft geverifieerd.',
      text_rejected: 'Je kunt nog steeds inloggen en je communities bekijken. Wijzigen blijft gesloten.',
      text_verified: 'Je kunt je communities maken en beheren.',
      title_pending: 'Je organisatie wordt gecontroleerd',
      title_rejected: 'Je registratie is niet goedgekeurd',
      lead_pending: 'Een Greenmapper-beheerder verifieert {organization}. Tot die tijd blijven je communities online voor fans en kun je ze hier bekijken.',
      lead_rejected: 'Een Greenmapper-beheerder kon {organization} niet verifiëren. Je communities blijven online voor fans en je kunt ze hier bekijken.',
      feedback_label: 'Bericht van Greenmapper',
      got_it: 'Begrepen',
      new_badge: 'Nieuw',
      step_registered: 'Geregistreerd',
      step_registered_text: 'Je eigenaarsaccount bestaat.',
      step_verification_pending: 'Verificatie, nu',
      step_verification_pending_text: 'Je hoeft niets te doen.',
      step_verification_rejected: 'Verificatie, niet goedgekeurd',
      step_verification_rejected_text: 'Zie het bericht hierboven.',
      step_manage: 'Communities beheren',
      step_manage_text: 'Communities maken en bewerken.',
      your_communities: 'Mijn communities',
      official_area: 'Officieel gebied',
      drawn_area: 'Getekend gebied',
      boundary_drawn: 'grens door jou getekend',
      fans: 'geen fans | 1 fan | {count} fans',
      summary_communities: 'geen communities | 1 community | {count} communities',
      community_verified: 'geverifieerd door Greenmapper',
      community_status_pending: 'Wacht op controle',
      community_fans_after_approval: 'Fans worden toegevoegd zodra de community is goedgekeurd.',
      community_status_verified: 'Geverifieerd',
      community_status_rejected: 'Afgewezen',
      edit: 'Bewerken',
      edit_community: '{title} bewerken',
      community_status_changed: 'Gewijzigd · wacht op controle',
      community_rejected_reason: 'Reden: {comment}',
      community_deleted: 'Je community ‘{title}’ is verwijderd door Greenmapper.',
      view_only: 'Alleen bekijken',
      no_communities_verified: 'Je hebt nog geen communities. Maak je eerste.',
      no_communities_waiting: 'Je hebt nog geen communities. Je kunt ze maken zodra je geverifieerd bent.'
    },
    community_edit: {
      title: 'Community bewerken',
      back: 'Terug',
      draw_title: 'Grens aanpassen',
      change_boundary: 'Grens aanpassen',
      official_read_only: 'Officiële grens: kan niet worden aangepast.',
      boundary_not_editable: 'Deze grens kan hier niet worden aangepast.',
      boundary_changed: 'Nieuwe grens, nog niet opgeslagen',
      rereview_hint: 'Na opslaan controleert Greenmapper de nieuwe grens opnieuw.',
      zone_removed: 'Met een nieuwe grens vervalt de fanzone: fans tellen dan binnen de grens.',
      use_boundary: 'Deze grens gebruiken',
      save: 'Opslaan',
      saved: 'Wijzigingen opgeslagen',
      not_found: 'Community niet gevonden.',
      leave_title: 'Wijzigingen weggooien?',
      leave_text: 'Je wijzigingen zijn nog niet opgeslagen.',
      leave_draw_text: 'Je wijzigingen aan de grens gaan verloren. De grens blijft zoals hij was.',
      leave_keep: 'Verder bewerken',
      leave_confirm: 'Weggooien'
    },
    admin_home: {
      title: 'Admin',
      text: 'In aanbouw: hier komt de homepagina voor admins.'
    },
    // the admin's e-mail templates and score settings (#341)
    email_templates: {
      title: 'E-mailsjablonen',
      empty: 'Geen e-mailsjablonen gevonden',
      col_key: 'Sleutel',
      col_description: 'Omschrijving'
    },
    score_settings: {
      title: 'Scores',
      empty: 'Geen score-instellingen gevonden',
      col_key: 'Sleutel',
      col_description: 'Omschrijving',
      col_value: 'Score'
    },
    admin_fans: {
      title: 'Fans',
      search: 'Naam, e-mail, tag of plaats',
      stat_day: 'Nieuw vandaag',
      stat_week: 'Nieuw in 7 dagen',
      stat_month: 'Nieuw in een maand',
      stat_year: 'Nieuw in een jaar',
      stat_total: 'Alle fans',
      col_name: 'Naam',
      col_email: 'E-mail',
      col_created: 'Geregistreerd',
      col_age: 'Leeftijd',
      col_gender: 'Geslacht',
      col_score: 'Score',
      col_locale: 'Taal',
      col_areas: 'Gebieden',
      col_funding: 'Funding',
      col_tags: 'Tags',
      col_subs: 'Volgt',
      funding_finished: 'Funding afgerond',
      funding_not_finished: 'Funding niet afgerond',
      empty: 'Geen fans gevonden.',
      areas_title: 'Gebieden',
      no_areas: 'Geen gebieden getekend.',
      profile_title: 'Profiel',
      log_title: 'Activiteitenlog',
      log_show: 'Tonen',
      log_hide: 'Verbergen',
      log_filter: 'Filter de log',
      log_empty: 'Geen logregels.',
      log_none_match: 'Geen regels die bij het filter passen.',
      log_failed: 'Kon de log niet laden',
      log_session: 'Sessie',
      log_geometry: 'Geometrie',
      log_scope: 'Schaal',
      registration_finished: 'Registratie afgerond',
      details: {
        user_id: 'Gebruikers-ID',
        created: 'Aangemaakt',
        email_verified: 'E-mail geverifieerd',
        place: 'Plaats',
        disclaimer: 'Disclaimer geaccepteerd',
        updated: 'Profiel gewijzigd',
        education: 'Opleiding',
        city: 'Woonplaats',
        communities: 'Communities',
        no_communities: 'Volgt geen communities',
        gone_communities: '{count} bestaat niet meer | {count} bestaan niet meer',
        funding: 'Financieringstoezegging',
        amount: 'Bedrag',
        reason: 'Reden',
        yes: 'ja',
        no: 'nee'
      }
    },
    // the admin's communities screen (#341)
    admin_communities: {
      // the row menu's link to the community's area facts (#533)
      area_facts: 'Feiten over het gebied',
      title: 'Communities',
      search: 'Naam, eigenaar of gebied',
      col_name: 'Community',
      col_owner: 'Eigenaar',
      col_area: 'Gebied',
      col_created: 'Gemaakt',
      col_status: 'Status',
      col_fanzone: 'Fanzone',
      col_fans: 'Fans',
      col_threads: 'Gesprekken',
      col_polls: 'Peilingen',
      col_polis: 'Polis',
      col_meetings: 'Bijeenkomsten',
      col_pledges: 'Toezeggingen',
      col_mods: 'Moderatoren',
      empty_waiting: 'Er wachten geen communities op controle.',
      empty_rejected: 'Geen afgewezen communities.',
      empty_verified: 'Nog geen goedgekeurde communities.',
      empty_all: 'Geen communities gevonden.',
      more_actions: 'Meer acties voor {title}',
      open: 'Community openen',
      edit: 'Bewerken',
      pending_done: '{title} wacht weer',
      reject_title: '{title} afwijzen?',
      facts_title: 'Community',
      description_title: 'Beschrijving',
      no_description: 'Geen beschrijving.',
      no_moderators: 'geen',
      content: 'Inhoud',
      fan_zone_fans: 'Fans in de zone',
      fan_zone_after_approval: 'bij goedkeuring toegevoegd',
      fan_zone_size: 'Fanzone',
      fan_zone_position: 'Stand',
      fan_zone_start: 'Aanbevolen',
      fan_zone_area: 'Gebied'
    },
    admin_owners: {
      title: 'Gebiedseigenaren',
      search: 'Naam, e-mail of organisatie',
      tab_waiting: 'Wachtend',
      tab_rejected: 'Afgewezen',
      tab_verified: 'Geverifieerd',
      tab_all: 'Alle',
      only_with_communities: 'Alleen eigenaren met communities',
      only_migrated: 'Wachtend sinds de migratie ({count})',
      load_failed: 'Eigenaren konden niet worden geladen',
      empty_waiting: 'Niemand wacht op verificatie.',
      empty_rejected: 'Geen afgewezen eigenaren.',
      empty_verified: 'Nog geen geverifieerde eigenaren.',
      empty_all: 'Geen eigenaren gevonden.',
      status_pending: 'Wachtend',
      status_rejected: 'Afgewezen',
      status_verified: 'Geverifieerd',
      personal_email: 'Persoonlijk e-mailadres',
      verify: 'Verifiëren',
      reject: 'Afwijzen',
      more_actions: 'Meer acties voor {name}',
      delete_owner: 'Eigenaar verwijderen',
      rejected_with: 'Afgewezen met:',
      reject_reason: 'Waarom wijs je {name} af?',
      reject_hint: 'De eigenaar ziet dit op de eigenaarspagina.',
      reject_delete_everything: 'Verwijder in plaats daarvan deze eigenaar en alles wat erbij hoort',
      reject_delete_hint: 'Verwijdert het account, de communities en fangebieden, en haalt die communities uit de abonnementen van fans. Je bevestigt de details in de volgende stap.',
      reject_delete_continue: 'Verder naar verwijderen',
      reject_owner: 'Eigenaar afwijzen',
      reject_title: '{name} afwijzen?',
      reject_dialog_text: 'De eigenaar kan nog inloggen en ziet je reden op de eigenaarspagina. Je kunt later alsnog verifiëren.',
      col_name: 'Eigenaar',
      col_organization: 'Organisatie',
      ago_now: 'nu',
      ago_min: '{n} min',
      ago_hours: '{n} u',
      ago_days: '{n} d',
      ago_months: '{n} mnd',
      ago_years: '{n} jr',
      change_status: 'Status wijzigen',
      set_pending: 'Terug naar wachtend',
      pending_done: '{name} wacht weer op verificatie',
      undo: 'Ongedaan maken',
      col_email: 'E-mail',
      col_status: 'Status',
      show_reason: 'Reden tonen',
      col_registered: 'Geregistreerd',
      col_communities: 'Communities',
      col_actions: 'Acties',
      col_area: 'Gebied',
      col_area_drawn: 'grens getekend',
      // who counts as a fan (#96)
      col_fan_zone: 'Fanzone',
      fan_zone_col_area: 'gebied',
      fan_zone_col_proposal: 'aanbevolen',
      fan_zone_title: 'Wie telt als fan',
      fan_zone_none: 'Geen fanzone: fans tellen binnen de grens van het gebied.',
      fan_zone_size: 'Fanzone: {size}',
      fan_zone_position: 'Stand: {position}',
      fan_zone_vs_start: '{change} ten opzichte van aanbevolen',
      fan_zone_start: 'Aanbevolen: {size}',
      fan_zone_area: 'Gebied: {size}',
      fan_zone_fans_waiting: 'Goedkeuren voegt {count} fans toe',
      fan_zone_fans: 'Fans in de zone: {count}',
      fan_zone_failed: 'De fanzone kon niet worden geladen.',
      col_verified: 'Geverifieerd',
      delete_title: '{name} verwijderen?',
      delete_text: 'Dit verwijdert het eigenaarsaccount definitief, en:',
      delete_no_communities: 'geen communities',
      delete_measures: 'geen fangebieden | 1 fangebied | {count} fangebieden',
      delete_type_to_confirm: 'Typ {name} om te bevestigen',
      delete_word: 'VERWIJDER',
      delete_final: 'Dit kan niet ongedaan worden gemaakt.',
      delete_confirm: 'Eigenaar verwijderen | Eigenaar en 1 community verwijderen | Eigenaar en {count} communities verwijderen',
      verified_done: '{name} is geverifieerd',
      rejected_done: '{name} is afgewezen',
      deleted_done: '{name} is verwijderd',
      community_verified: 'Community {title} geverifieerd',
      community_reject: 'Afwijzen',
      community_reject_title: 'Community afwijzen',
      community_reject_text: 'De community blijft werken voor de fans. De eigenaar ziet je reden op zijn dashboard.',
      community_reject_reason: 'Waarom wijs je {title} af?',
      community_rejected: 'Afgewezen',
      community_changed: 'gewijzigd',
      community_changed_was_verified: 'Nieuwe grens op {date}; was geverifieerd',
      community_changed_was_rejected: 'Nieuwe grens op {date}; was afgewezen',
      community_rejected_done: 'Community {title} afgewezen',
      community_reject_delete: 'Verwijder in plaats daarvan deze community',
      community_reject_delete_hint: 'Voor nep- of testcommunities. Je ziet in de volgende stap wat er verwijderd wordt.',
      community_delete_title: '{title} verwijderen?',
      community_delete_text: 'Dit verwijdert de community definitief, en:',
      community_delete_fans: 'geen fans verliezen hun abonnement | 1 fan verliest het abonnement | {count} fans verliezen hun abonnement',
      community_delete_content: 'geen berichten, peilingen, bijeenkomsten of toezeggingen | 1 bericht, peiling, bijeenkomst of toezegging | {count} berichten, peilingen, bijeenkomsten en toezeggingen',
      community_delete_official: 'het officiële gebied {name} komt weer vrij',
      community_delete_confirm: 'Community verwijderen',
      community_delete_reason: 'Reden voor de eigenaar',
      community_delete_reason_hint: 'De eigenaar ziet dit op zijn dashboard.',
      community_deleted_done: 'Community {title} is verwijderd'
    },
    maintenance: {
      title: 'Onderhoud',
      subtitle: 'Eenmalige datataken voor superadmins. Elke uitvoering wordt op de server gelogd.',
      environment: {
        dev: 'Ontwikkeling',
        test: 'Test',
        production: 'Productie'
      },
      load_failed: 'Onderhoudstaken konden niet worden geladen',
      retry: 'Opnieuw',
      empty: 'Er zijn geen onderhoudstaken.',
      status: 'Huidige status',
      last_result: 'Resultaat van {action} ({time})',
      unavailable: 'Niet beschikbaar in de huidige status',
      buttons: 'Wat de knoppen doen',
      run_failed: 'Taak mislukt',
      run_done: '{action} voltooid',
      confirm_title: 'Weet je het zeker?',
      confirm_message: 'Je gaat "{action}" van "{task}" uitvoeren op deze omgeving.',
      confirm_changes: 'Dit wijzigt data.',
      confirm_button: 'Uitvoeren',
      cancel: 'Annuleren',
      yes: 'Ja',
      no: 'Nee',
      todo_title: 'Te doen op deze server',
      todo_none: 'Niets te doen op deze server.',
      all_apply: 'Alles uitvoeren',
      all_only_after: 'Alles uitvoeren herstelt en controleert dan alleen de vormen.',
      all_confirm: 'Eerst draait de proefrun van elke stap. Lukt die, dan worden deze stappen na elkaar uitgevoerd, in deze volgorde:',
      all_confirm_order: 'Mislukt de proefrun, dan verandert er niets en zie je waarom. Een stap die daarna mislukt stopt de rest; de stappen ervoor blijven gedaan. Inkorten tot een steekproef hoort er niet bij: dat blijft een eigen knop. Maak op productie eerst een databaseback-up.',
      all_result_apply: 'Alles uitvoeren ({time})',
      'all_result_dry-run': 'Proefrun mislukt, er is niets veranderd ({time})',
      all_no_dry_run: 'Geen proefrun: deze stap wordt gewoon uitgevoerd.',
      all_done: 'Alles uitgevoerd',
      'all_failed_dry-run': 'Proefrun mislukt bij {step}: er is niets veranderd',
      all_failed_apply: 'Gestopt: {step} is mislukt',
      lists_title: 'Gebiedslijsten',
      per_list: 'Eén lijst tegelijk',
      per_list_hint: 'Proefdraaien, importeren, verwijderen of inkorten van één lijst. Meestal is Alle lijsten importeren hierboven genoeg.',
      other_tools: 'Overige hulpmiddelen',
      // a test error for Sentry (#320)
      sentry: {
        title: 'Sentry-testfout',
        description: 'Veroorzaakt een echte fout op deze pagina, zoals een bug dat doet. In Sentry hoort hij deze omgeving en release te tonen, jou als gebruiker (id en e-mail), en het bestand en de regel in src/pages/AdminMaintenancePage.vue.',
        off: 'Sentry staat uit op dev: de fout gaat alleen naar de browserconsole en logs/browser.log.',
        button: 'Veroorzaak een testfout',
        col_release: 'Release',
        col_event: 'Sentry-melding',
        sent: 'Testfout naar Sentry gestuurd: melding {id}',
        thrown: 'Testfout veroorzaakt (Sentry staat hier uit)'
      },
      col_list: 'Lijst',
      col_version: 'Versie die eigenaren zien',
      col_bundle: 'Nieuwste bundel',
      col_entries: 'Vermeldingen',
      entries_note: 'Vermeldingen: alles wat in de lijst staat. De filters van Zoek je gebied tellen minder: een gebied dat ook in een andere lijst staat telt daar één keer, onder één lijst.',
      col_state: 'Stand',
      state_current: 'Bijgewerkt',
      state_newer: 'Nieuwere bundel',
      state_not_imported: 'Niet geïmporteerd',
      state_sample: 'Steekproef',
      state_no_bundle: 'Geen bundel',
      details: 'Details',
      tasks: {
        'pledge-points-to-areas': {
          todo: {
            apply: '{points} toezeggingen hebben een punt als plek: maak er kleine gebieden van.'
          },
          title: 'Toezeggingspunten naar gebieden',
          description: 'Geeft elke toezegging met een los punt als plek een klein rond gebied (50 m) rond dat punt, want de toezeggingswizard tekent alleen gebieden. De eigenaar kan het opnieuw tekenen. Maak eerst een back-up van de database op productie.',
          help: {
            'dry-run': 'Telt de toezeggingen met een punt. Verandert niets.',
            apply: 'Maakt van die punten gebieden en onthoudt ze, zodat Terugdraaien het ongedaan kan maken.',
            rollback: 'Zet de punten terug bij de toezeggingen waarvan het gebied nog dat van Toepassen is; een gebied dat een eigenaar opnieuw tekende blijft.'
          },
          actions: {
            'dry-run': 'Proefrun',
            apply: 'Toepassen',
            rollback: 'Terugdraaien'
          },
          fields: {
            points: 'Toezeggingen met een punt',
            communities: 'Communities met zulke toezeggingen',
            applied: 'Door Toepassen veranderd (terug te draaien)',
            changed: 'Toezeggingen veranderd',
            restored: 'Punten teruggezet',
            redrawn: 'Sindsdien opnieuw getekend (blijven zo)',
            unreadable: 'Onleesbare punten (blijven zo)',
            rolledBack: 'Teruggedraaid (geen taak meer; Toepassen kan nog)',
            gone: 'Sindsdien verwijderd (niets terug te zetten)'
          },
          unavailable: {
            'no-points': 'Geen toezegging heeft een punt.',
            'nothing-applied': 'Niets toegepast om terug te draaien.'
          }
        },
        'fan-subscriptions-cleanup': {
          todo: {
            apply: '{fans} fans volgen een verwijderde gemeenschap of één gemeenschap dubbel: ruim hun abonnementen op.'
          },
          title: 'Fan-abonnementen opschonen',
          description: 'Schoont de abonnementen van de fans eenmalig op: abonnementen op communities die niet meer bestaan verdwijnen, en een community die een fan meer dan eens volgt blijft één keer staan. De scores van de fans blijven zoals ze zijn. Maak eerst een databaseback-up voordat je dit op productie toepast.',
          help: {
            'dry-run': 'Telt wat er zou veranderen. Verandert niets.',
            apply: 'Schoont die abonnementen op. Een fan die zich tussen de proefrun en Toepassen ergens op abonneert, komt bij de volgende run aan de beurt. Maak op productie eerst een databaseback-up.'
          },
          actions: {
            'dry-run': 'Proefrun',
            apply: 'Toepassen'
          },
          fields: {
            fans: 'Op te schonen fans',
            fansWithGone: 'Fans die een verwijderde community volgen',
            gone: 'Abonnementen op verwijderde communities',
            fansWithDuplicates: 'Fans die een community meer dan eens volgen',
            duplicates: 'Dubbele abonnementen',
            changed: 'Opgeschoonde fans',
            skipped: 'Overgeslagen fans (intussen gewijzigd: nog eens draaien)',
            landsWithoutId: 'Communities zonder id'
          },
          unavailable: {
            clean: 'Niets op te schonen.',
            'lands-without-id': 'Niet mogelijk: {landsWithoutId} communities hebben geen id, dus hun abonnementen zijn niet te onderscheiden van verwijderde.'
          }
        },
        'area-facts': {
          warnings: {
            none: 'Feiten over gebieden staan aan, maar er zijn nog geen feiten: download de grenzen, bouw een bundel met build.py en importeer hem (docs/claude/explain/area-facts.md).',
            missing: 'Communities zonder feiten over het gebied: {n}. Ze komen met de volgende bundel van deze site (grenzen downloaden, build.py, importeren).'
          },
          todo: {
            import: 'Er staat een nieuwe bundel met feiten over gebieden klaar: {bundle}. Importeer hem.'
          },
          title: 'Feiten over gebieden',
          description: 'De feiten van elke community en elke plek van een fan uit open data (landgebruik, beschermde gebieden, waarnemingen in GBIF), offline berekend door docs/claude/polygon-lists/area-facts/build.py uit de grenzen die je hier downloadt, en getoond op de pagina Feiten over het gebied van een community. De downloads: de grenzen voor de bouwer (een fan alleen als pseudoniem), en de export voor onderzoek als CSV of GeoJSON (codeboek: docs/claude/explain/area-facts.md).',
          help: {
            'switch-on': 'Zet het experiment aan: de pagina Feiten over het gebied, het menu-item bij Communities en de downloads.',
            'switch-off': 'Zet het experiment uit: de pagina, het menu-item en de downloads verdwijnen; de feiten blijven (Verwijderen wist ze).',
            'dry-run': 'Leest de nieuwste bundel en telt wat Importeren zou houden en weigeren. Verandert niets.',
            import: 'Vervangt de feiten door die van de nieuwste bundel.',
            remove: 'Verwijdert alle feiten over gebieden.',
            'download-outlines': 'De grens van elke community en plek van een fan, voor build.py: een fan alleen als pseudoniem, geen naam of e-mail.',
            'download-csv': 'Eén rij per community en plek van een fan: de feiten, de antwoorden bij een plek, geen persoonlijke velden.',
            'download-geojson': 'Dezelfde rijen met hun grenzen.'
          },
          actions: {
            'switch-on': 'Aanzetten',
            'switch-off': 'Uitzetten',
            'dry-run': 'Proefdraaien',
            import: 'Importeren',
            remove: 'Verwijderen',
            'download-outlines': 'Grenzen downloaden',
            'download-csv': 'CSV downloaden',
            'download-geojson': 'GeoJSON downloaden'
          },
          fields: {
            on: 'Aan',
            bundle: 'Nieuwste bundel',
            imported: 'Geïmporteerde bundel',
            importedAt: 'Geïmporteerd op',
            records: 'Feiten',
            refused: 'Geweigerd',
            withoutFacts: 'Zonder feiten',
            lands: 'Communities',
            places: 'Plekken van fans',
            file: 'Bestand',
            size: 'Grootte (bytes)',
            version: 'Versie',
            removed: 'Verwijderd'
          },
          unavailable: {
            off: 'Het experiment staat uit: zet het eerst aan.',
            no_bundle: 'Nog geen bundel in _area-facts/bundles.',
            nothing: 'Nog geen feiten over gebieden geïmporteerd.'
          }
        },
        'log-sessions': {
          todo: {
            apply: '{rows} logregels hebben de inlogtoken van een fan als sessie: vervang ze.'
          },
          title: 'Inlogtokens in de logs',
          description: 'Tot #577 bewaarden de wizard voor een gebied en de financieringsvragenlijst de inlogtoken van de fan als sessie van elke logregel; daarmee kon je als die fan inloggen. Vervangt elke zo\'n sessie door een willekeurige id; de regels van één login blijven bij elkaar.',
          help: {
            'dry-run': 'Telt de regels en sessies. Verandert niets.',
            apply: 'Vervangt die sessies door willekeurige id\'s. Kan niet ongedaan worden gemaakt, en dat is de bedoeling.'
          },
          actions: {
            'dry-run': 'Proefrun',
            apply: 'Toepassen'
          },
          fields: {
            rows: 'Regels met een inlogtoken',
            sessions: 'Sessies (bezoeken)'
          },
          unavailable: {
            clean: 'Niets te vervangen.'
          }
        },
        'score-duplicates': {
          todo: {
            apply: '{extra} scorewaarden staan er dubbel in (een data-import): verwijder de extra kopieën.'
          },
          title: 'Dubbele scorewaarden',
          description: 'Verwijdert de tweede kopie van de scorewaarden (Gebied tekenen, Virtuele financiering, Reactie in discussie, Toezegging) die een data-import achterliet: de pagina Scores toonde elke waarde twee keer, en een wijziging kwam maar bij één kopie. Houdt de kopie die de testserver heeft, anders de eerste. Een waarde waarvan de kopieën verschillen, blijft voor jou. Elke verwijderde kopie wordt bewaard: Terugdraaien zet ze terug. Alles uitvoeren voert het na een deploy uit; na Terugdraaien wacht het op Toepassen met de hand.',
          help: {
            'dry-run': 'Toont de dubbele waarden en telt de kopieën die Toepassen zou verwijderen. Verandert niets.',
            apply: 'Verwijdert de extra kopieën; per waarde blijft er één.',
            rollback: 'Zet elke kopie die Toepassen verwijderde terug.'
          },
          actions: {
            'dry-run': 'Proefrun',
            apply: 'Toepassen',
            rollback: 'Terugdraaien'
          },
          fields: {
            extra: 'Extra kopieën',
            keys: 'Dubbele waarden',
            differing: 'Kopieën die verschillen (blijven staan)',
            removed: 'Verwijderde kopieën',
            appliedAt: 'Laatst toegepast',
            rolledBackAt: 'Teruggedraaid op',
            changedSince: 'Score sindsdien gewijzigd',
            restored: 'Teruggezette kopieën'
          },
          unavailable: {
            clean: 'Niets dubbel.',
            'nothing-applied': 'Niets toegepast om terug te draaien.',
            'changed-since': 'Niet meer mogelijk: een score is sinds Toepassen gewijzigd, en de oude kopie zou hem verdubbelen met een andere waarde.'
          },
          warnings: {
            'values-differ': 'De kopieën van {keys} hebben verschillende waarden: de score hangt af van welke kopie de database teruggeeft. Verwijder de verkeerde kopie met de hand.'
          }
        },
        'owner-status-migration': {
          todo: {
            apply: 'De migratie van de eigenaarstatus is op deze server nog niet toegepast.'
          },
          title: 'Migratie eigenaarstatus',
          description: 'Geeft elke bestaande eigenaar zonder status de status wachtend, ook eigenaren die admin zijn. Een admin verifieert daarna elke eigenaar met de hand op het scherm Gebiedseigenaren. Maak een databaseback-up voordat je dit op productie toepast.',
          help: {
            'dry-run': 'Telt de eigenaren zonder status; ze zouden allemaal wachtend worden. Verandert niets. Het aantal wordt onthouden en vergeleken met wat Toepassen verandert.',
            apply: 'Maakt die eigenaren wachtend, één keer. Daarna: open Gebiedseigenaren, vink "Wachtend sinds de migratie" aan en verifieer de echte eigenaren, die met communities en fans eerst. Tot dan kunnen ze hun communities niet beheren. Maak op productie eerst een databaseback-up.',
            rollback: 'Haalt de status weer weg bij precies de eigenaren die Toepassen veranderde. Kan alleen zolang geen admin een van hen heeft geverifieerd of afgewezen: daarna schakelt het zichzelf uit.'
          },
          actions: {
            'dry-run': 'Proefdraaien',
            apply: 'Toepassen',
            rollback: 'Terugdraaien'
          },
          fields: {
            applied: 'Toegepast',
            appliedAt: 'Toegepast op',
            owners: 'Eigenaren',
            pending: 'Naar wachtend',
            dryRunOwners: 'Eigenaren bij het proefdraaien ervoor',
            adminDecisions: 'Sindsdien door een admin beslist',
            rolledBack: 'Eigenaren teruggedraaid'
          },
          unavailable: {
            'admin-decided': 'Kan niet meer: een admin heeft al over {adminDecisions} van de gemigreerde eigenaren beslist, en terugdraaien zou dat ongedaan maken.'
          },
          warnings: {
            'count-differs': 'Toepassen veranderde {applied} eigenaren, maar het proefdraaien ervoor telde er {dryRun}. Controleer op het scherm Gebiedseigenaren of de juiste eigenaren wachtend zijn.'
          }
        },
        'geometry-check': {
          todo: {
            never_run: 'De geometriecontrole heeft op deze server nog nooit gedraaid.'
          },
          title: 'Vormcontrole',
          description: 'Controleert elke plek van een fan, elke communitygrens en elk thuisadres op fouten: ontbrekende of kapotte vormen, kruisende lijnen, vormen op de verkeerde plek (op 0,0, breedte- en lengtegraad verwisseld, ver van huis), veel te klein of te groot, onmogelijke niveaus, dubbele en verweesde vormen. Leest alleen: verandert niets. Loopt op de achtergrond; de aantallen staan hier als hij klaar is.',
          help: {
            run: 'Controleert de database van deze omgeving.',
            'run-copy': 'Controleert de kopie van een database die ervoor is ingesteld (settings: geometryCheck.copyUrl), bijvoorbeeld een kopie van productie op dev.'
          },
          actions: {
            run: 'Controleren',
            'run-copy': 'Kopie controleren'
          },
          fields: {
            lastRun: 'Laatste controle',
            state: 'Stand',
            source: 'Database',
            startedAt: 'Gestart',
            finishedAt: 'Klaar',
            checked: 'Gecontroleerd',
            defects: 'Fouten',
            error: 'Fout',
            started: 'Gestarte controle'
          },
          unavailable: {
            running: 'Er loopt al een controle.',
            'no-copy': 'Er is geen kopie van een database ingesteld.'
          }
        },
        'geometry-fix': {
          title: 'Vormen herstellen',
          description: 'Herstelt de plekken van fans zoals besloten in issue #76: vormen met kruisende lijnen worden ontward, dubbelklikpunten verwijderd, vormen over de rand van de kaart teruggeschoven of afgeknipt, plekken op 0,0 naar het huis van de fan verplaatst, kopieën en plekken van verwijderde gebruikers verwijderd, onmogelijke niveaus rechtgezet, en een fan die zijn registratie afrondde krijgt een plek op elk niveau (ontbrekende worden rond het huis aangemaakt, gemarkeerd als aangemaakt). De oude versie van elke gewijzigde plek wordt bewaard: Terugdraaien zet alles terug.',
          help: {
            'dry-run': 'Telt wat elke herstelling in deze database zou veranderen. Verandert niets.',
            apply: 'Voert alle herstellingen in één keer uit in deze database. Maak op productie eerst een back-up van de database.',
            rollback: 'Zet alles terug wat de laatste Uitvoeren veranderde, uit de bewaarde oude versies.',
            'dry-run-copy': 'Proefrun op de kopie van de database (settings: geometryCheck.copyUrl).',
            'apply-copy': 'Uitvoeren op de kopie van de database.',
            'rollback-copy': 'Terugdraaien op de kopie van de database.'
          },
          actions: {
            'dry-run': 'Proefrun',
            apply: 'Uitvoeren',
            rollback: 'Terugdraaien',
            'dry-run-copy': 'Proefrun (kopie)',
            'apply-copy': 'Uitvoeren (kopie)',
            'rollback-copy': 'Terugdraaien (kopie)'
          },
          fields: {
            lastRun: 'Laatst uitgevoerd',
            lastRunCopy: 'Laatst uitgevoerd op de kopie',
            run: 'Uitvoering',
            changes: 'Wijzigingen',
            left: 'Niet te herstellen'
          },
          unavailable: {
            'no-copy': 'Er is geen kopie van een database ingesteld.',
            'nothing-applied': 'Er is niets uitgevoerd om terug te draaien.'
          }
        },
        'polygon-lists': {
          title: 'Alle gebiedslijsten',
          description: 'Importeert in één keer elke lijst met een nieuwere bundel en past daarna één keer de gebiedsgroepen toe.',
          help: {
            'import-all': 'Importeert de nieuwste bundel van elke lijst met een nieuwere dan die eigenaren nu zien (of die nog nooit is geïmporteerd), de ene lijst na de andere, en past daarna één keer de gebiedsgroepen toe. Bijgewerkte lijsten worden overgeslagen. Grote lijsten (WDPA) duren vele minuten.',
            'prune-all': 'Alleen op de testserver. Kort elke volledige lijst in tot haar steekproef van ongeveer 100 gebieden (elke keer dezelfde); gebieden waar een gemeenschap op staat blijven.'
          },
          actions: {
            'import-all': 'Alle lijsten importeren',
            'prune-all': 'Alle lijsten inkorten tot steekproef'
          },
          fields: {
            lists: 'Lijsten',
            active: 'Lijsten waaruit eigenaren kiezen',
            withBundle: 'Lijsten met een bundel',
            toPrune: 'Volledige lijsten om in te korten',
            toImport: 'Nieuwere bundels om te importeren',
            samples: 'Lijsten die een steekproef zijn',
            imported: 'Geïmporteerd',
            pruned: 'Ingekort tot steekproef',
            groups: 'Gebiedsgroepen',
            groupsFile: 'Bestand met gebiedsgroepen'
          },
          unavailable: {
            all_current: 'Elke lijst is bijgewerkt.',
            all_samples: 'Elke lijst is al een steekproef.',
            no_bundles: 'Er staan geen bundels in de importmap.',
            nothing_imported: 'Er is nog geen lijst geïmporteerd.',
            small_lists: 'De volledige lijsten hebben 100 gebieden of minder.'
          },
          todo: {
            import: 'Nieuwe bundels om te importeren: {lists}.'
          }
        },
        'polygon-list': {
          title: 'Gebiedslijst: {list}',
          description: 'Importeert deze polygonenlijst uit de nieuwste bundel in haar map (<importmap>/<lijst>/bundles), gecontroleerd tegen het .sha256-bestand. Een lijst heeft één versie: Importeren laadt de nieuwe gebieden naast de oude, schakelt de lijst om als alles binnen is en verwijdert daarna de oude. Terugdraaien bestaat niet: zet daarvoor een oudere bundel in de map en importeer die. Gemeenschappen houden hun eigen grens en gegevens, wat er ook met de lijst gebeurt.',
          help: {
            'dry-run': 'Leest de nieuwste bundel en controleert elk gebied. Toont hoeveel gebieden er zijn, per status, en eventuele problemen. Verandert niets.',
            import: 'Importeert de nieuwste bundel en maakt die de versie waaruit eigenaren kiezen, in plaats van de vorige. Wordt geweigerd als een gebied een probleem heeft (zie Proefdraaien); er verandert dan niets.',
            remove: 'Haalt de lijst weg bij eigenaren en verwijdert al haar gebieden. Gemeenschappen erop houden hun grens en gegevens.',
            prune: 'Alleen op de testserver. Houdt ongeveer 100 gevarieerde gebieden van deze lijst over (statussen, groottes, beginletters, landen, met en zonder fanomtrek) en verwijdert de rest, zodat test klein en snel blijft. Elke keer dezelfde gebieden. Gebieden waar een gemeenschap op staat blijven altijd. De volledige lijst terug: importeer haar opnieuw.'
          },
          actions: {
            'dry-run': 'Proefdraaien',
            import: 'Importeren',
            remove: 'Lijst verwijderen',
            prune: 'Inkorten tot steekproef'
          },
          fields: {
            listKey: 'Lijst',
            bundle: 'Nieuwste bundel',
            bundleMB: 'Grootte (MB)',
            activeDatasetVersion: 'Versie voor eigenaren',
            importedFile: 'Geïmporteerde bundel',
            importedAt: 'Geïmporteerd op',
            entries: 'Gebieden in de database',
            file: 'Bestand',
            sha256: 'Controlegetal',
            datasetVersion: 'Versie in de bundel',
            withPolygon: 'Met polygoon',
            problems: 'Problemen',
            problemExamples: 'Voorbeelden van problemen',
            currentVersion: 'Huidige versie',
            currentEntries: 'Huidige gebieden',
            official: 'Officiële grens',
            accepted: 'Geaccepteerd',
            partial: 'Alleen kerngebied',
            proxy: 'Benaderd gebied',
            review: 'Te beoordelen (eigenaar tekent)',
            missing: 'Geen polygoon (eigenaar tekent)',
            imported: 'Geïmporteerd',
            removedOld: 'Oude gebieden verwijderd',
            communities: 'Gemeenschappen op deze lijst',
            aliases: 'Kopieën samengevoegd in een ander gebied (aliassen)',
            movedCommunities: 'Communities verplaatst van een kopie naar zijn gebied',
            notMovedCommunities: 'Communities op een kopie gebleven (zijn gebied heeft er al een)',
            removed: 'Gebieden verwijderd',
            listRemoved: 'Lijst verwijderd',
            groupedEntries: 'Gebieden in een groep',
            groupsFile: 'Bestand met gebiedsgroepen',
            groups: 'Gebiedsgroepen',
            groupsError: 'Gebiedsgroepen niet toegepast',
            prunedAt: 'Ingekort tot steekproef op',
            prunedFrom: 'Gebieden voor het inkorten',
            kept: 'Gebieden over',
            sample: 'In de steekproef',
            keptInUse: 'Over omdat er een gemeenschap op staat'
          },
          unavailable: {
            no_bundle: 'Er staat geen bundel in de map van deze lijst.',
            not_imported: 'De lijst is nog niet geïmporteerd.',
            already_pruned: 'De lijst is al een steekproef. Importeer haar opnieuw voor de volledige lijst.',
            small_list: 'De lijst heeft al 100 gebieden of minder.'
          },
          warnings: {
            groups_stale: 'De gebiedsgroepen ({file}) zijn gemaakt voor een andere versie van de lijst “{list}”: de gebieden ervan zitten in geen groep. Draai groups.py voor de lijsten zoals ze nu zijn en zet het nieuwe bestand in de map _groups.',
            groups_waiting: 'Er staat een nieuwer bestand met gebiedsgroepen ({file}) in de map _groups: het wordt toegepast bij de volgende import van een lijst of als de server start.'
          }
        }
      }
    },
    home: {
      title: 'Home'
    },
    moderators: {
      title: 'Moderators',
      mod_requests: 'Moderator verzoeken',
      mods: 'Moderators',
      accept: 'Accepteren',
      deny: 'Weigeren'
    },
    create_community: {
      title: 'Maak community'
    },
    land_owner_register: {
      title: 'Land-eigenaar registratie',
      steps: {
        general: {
          nav_title: 'Algemen info',
          title: 'Landeigenaar informatie',
          task_title: 'Geef enige algemene informatie over het land dat je bezit/beheert',
          email: 'E-mail'
        },
        draw: {
          nav_title: 'Kaart',
          title: 'Teken gebied',
          task_title: 'Teken je gebied'
        },
        description: {
          nav_title: 'Omschrijving',
          title: 'Beschrijf je community',
          task_title: 'Geef een titel die je community beschrijft',
          input_title: 'Titel',
          input_title_error: 'Maximaal {max} karakters',
          input_description: 'Omschrijving',
          task_description: 'Beschrijf wat juist deze community aantrekkelijk, waardevol of belangrijk maakt',
          input_description_error: 'Maximaal {max} karakters'
        },
        finalize: {
          title: 'Informatie',
          task_title: 'Dank voor het verstrekken van deze informatie, als je op Afronden klikt, kunnen we je community aanmaken. Om te discussiëren met je community kun je een discussie aanmaken. Klik op de 3 puntjes rechts van \'discussie\' om een nieuwe discussie aan te maken.'
        }
      }
    },
    pledge: {
      count: 'Aantal toezeggingen',
      part1: 'toegezegd van',
      part2: 'doel',
      question: 'Zou je iets willen <b>toezeggen</b> uit je virtuele natuurbudget voor dit project?',
      yes: 'Ja, ik <b>wil</b> iets toezeggen aan dit project',
      no: 'Nee, ik wil <b>niets</b> toezeggen aan dit project',
      delete_title: 'Toezegging verwijderen',
      delete_text: 'Wil je deze toezegging echt verwijderen?'
    },
    add_pledge: {
      title: 'Geef het bedrag aan dat je zou willen toezeggen voor het financieren van dit project.',
      reason: 'Zou je willen toelichten waarom je voor dit bedrag hebt gekozen?',
      reasonNo: 'Zou je willen toelichten waarom je niet aan dit project wilt toezeggen?',
      confirm_text1: 'Je stelt momenteel voor om',
      confirm_text2: 'van je aangegeven jaarlijkse natuurbudget aan dit project toe te zeggen. Wil je dit bedrag bevestigen?',
      confirm: 'Ik bevestig',
      budget_hint: 'Je natuurbudget: € {amount} per jaar'
    },
    add_treasure: {
      title_nav: 'Maak treasure aan',
      photos: 'Fotos',
      title: 'Upload foto van treasures',
      description: 'Beschrijf waarom je deze plek mooi vindt. Deel een tekening, gedicht, afbeelding of een kort verhaal.',
      upload: 'Upload foto (.jpg)',
      describe_title: 'Geef je treasure een titel',
      describe_text: 'Vertel in je eigen woorden wat deze treasure aantrekkelijk, waardevol of belangrijk voor je maakt',
      pin_hint: 'Tik op de kaart waar je treasure is.',
      pin_move: 'Sleep de speld of tik ergens anders om hem te verplaatsen.',
      pin_outside: 'Deze plek ligt buiten het gebied van de community.',
      show_area: 'Toon het hele gebied'
    },
    create_pledge: {
      title_nav: 'Maak toezegging aan',
      title: 'Beschrijf je financieringsverzoek met een pakkende titel.',
      description: 'Beschrijf je financieringsverzoek in meer detail. Geef achtergrondinformatie, voorgestelde acties, verwachte resultaten en wat je donateurs ervoor terugkrijgen.',
      type: 'Soort toezegging',
      fixed: 'Vast',
      fixed_desc: 'Verzoek om eenmalige financiering',
      yearly: 'Jaarlijks',
      yearly_desc: 'Verzoek om jaarlijks terugkerende financiering',
      '2yearly': 'Per 2 jaar',
      '2yearly_desc': 'Verzoek om financiering die elke 2 jaar terugkeert',
      '3yearly': 'Per 3 jaar',
      '3yearly_desc': 'Verzoek om financiering die elke 3 jaar terugkeert',
      '4yearly': 'Per 4 jaar',
      '4yearly_desc': 'Verzoek om financiering die elke 4 jaar terugkeert',
      '5yearly': 'Per 5 jaar',
      '5yearly_desc': 'Verzoek om financiering die elke 5 jaar terugkeert',
      goal: 'Geef je streefbedrag aan in euro\'s',
      goal_error: 'Maximaal € {max}',
      map_title: 'Teken het gebied van je toezegging',
      map_outside: 'Je gebied ligt deels buiten het gebied van de community.'
    },
    edit_pledge: {
      title_nav: 'Aanpassen pledge'
    },
    create_message: {
      sent: 'Het bericht is verstuurd',
      no_communities: 'Geen communities',
      title_nav: 'Bericht maken',
      steps: {
        community: {
          nav_title: 'Community',
          ask: 'Kies de <b>community</b> waar het bericht naartoe gaat. Het gaat naar <b>alle</b> leden.',
          title: 'Select the <b>community</b> to sent the message to its <b>all fans</b> ect</p>'
        },
        message: {
          nav_title: 'Bericht',
          title_ask: 'Geef je bericht een korte, pakkende titel.',
          body_ask: 'Beschrijf waar het over gaat, geef achtergrond en zeg wat je van de leden verwacht. Houd het kort en concreet.'
        },
        finalize: {
          nav_title: 'Afronden',
          ask: 'Zo zien de leden van de community het.'
        }
      }
    },
    create_thread: {
      title_nav: 'Maak discussie aan',
      title_nav_edit: 'Pas discussie aan',
      title: 'Geef een titel',
      description: 'Geef eerste aanzet voor de discussie',
      options: 'Voeg poll opties toe',
      option: 'optie',
      upload: 'Upload fotos (.jpg)'
    },
    create_poll: {
      preview: 'Voorbeeld',
      title_nav: 'Maak peiling aan',
      title_nav_edit: 'Pas peiling aan',
      title: 'Geef een titel',
      description: 'Geef eerste aanzet voor de discussie',
      upload: 'Upload fotos (.jpg)',
      options: 'Voeg antwoorden toe',
      option: 'Antwoord'
    },
    create_polis: {
      id_label: 'Polis-id',
      title_nav: 'Maak polis aan',
      title_nav_edit: 'Pas Polis aan',
      title: 'Geef een titel',
      id: 'Geef het polis ID op',
      voter_option: 'Alleen leden van de community kunnen stemmen'
    },
    create_meeting: {
      date: 'Datum',
      time: 'Tijd',
      title_nav: 'Maak bijeenkomst aan',
      title_nav_edit: 'Pas bijeenkomst aan',
      title: 'Geef een titel',
      description: 'Geef een omschrijving',
      url: 'Geef externe url van de online bijeenkomst',
      dateTime: 'Starttijd & datum'
    },
    send_invites: {
      title_nav: 'Uitnodigingen versturen',
      step: 'Kies',
      number: 'Aantal willekeurig uitgenodigde leden',
      number_label: 'Aantal uitnodigingen',
      max_error: 'Hoogstens {max} uitnodigingen',
      sent: 'De e-mails zijn verstuurd'
    },
    meeting: {
      deleted: 'De bijeenkomst is verwijderd',
      delete_title: 'Bijeenkomst verwijderen',
      delete_text: 'Weet je zeker dat je deze bijeenkomst wilt verwijderen?',
      total_subs: 'Totaal aantal leden',
      accepted_invites: 'Geaccepteerde uitnodigingen',
      rejected_invites: 'Geweigerde uitnodigingen',
      planned_label: 'gepland op',
      invited_banner: 'Je bent uitgenodigd voor deze bijeenkomst',
      accepted_banner: 'Je hebt de uitnodiging geaccepteerd, als je geselecteerd wordt ontvang je een e-mail met verdere details over de bijeenkomst.',
      rejected_banner: 'Je hebt de uitnodiging geweigerd',
      send_banner: 'Stuur de link voor de bijeenkomst naar de leden die de uitnodiging hebben geaccepteerd.',
      resend_banner: 'Stuur de link voor de bijeenkomst opnieuw. Let op: je hebt de url reeds verstuurd!'
    },
    landing: {
      my_portal: 'My Xena'
    },
    welcome: {
      // the links between the visitor's pages (#442)
      no_account: 'Nog geen account?',
      to_register: 'Maak account aan',
      have_account: 'Al een account?',
      to_login: 'Inloggen',
      back_to_login: 'Terug naar inloggen',
      title: 'Welkom bij Greenmapper',
      introduction: 'Introductie',
      subtitle_1: 'Markeer natuur- en landschapsplekken',
      paragraph_1: 'In Greenmapper Friends markeer je <b>natuur- of landschapsplekken</b> met <b>groen en/of water</b> die voor jou <b>aantrekkelijk, waardevol of belangrijk</b> zijn. Een plek kan klein of groot zijn, in of buiten stad of dorp. Je kunt er vaak komen, zelden komen of een plek vooral kennen van verhalen of foto’s.',
      subtitle_2: 'Waarom registreren?',
      paragraph_2: 'Elke gemarkeerde plek is een plek waar je een <b>online vriend</b> van kunt zijn. Daarom vragen we enkele gegevens om een account aan te maken. Alleen je <b>schermnaam</b> is zichtbaar voor andere gebruikers.',
      subtitle_3: 'Privacy',
      paragraph_3: 'Greenmapper Friends is een initiatief van de Rijksuniversiteit Groningen. Je e-mailadres wordt opgeslagen in de Greenmapper Landscape Friend Registry (GLFR) en is alleen toegankelijk voor de Greenmapper-organisatie. Via het platform kunnen landeigenaren, beheerders of andere vrienden je alleen anoniem bereiken; zij krijgen nooit direct toegang tot je e-mailadres. We werken volgens AVG/GDPR.',
      continue_without_account: 'Doorgaan zonder account',
      forgot_password: 'Wachtwoord vergeten?',
      forgot_password_dialog: 'Vul je e-mailadres in. Je krijgt een link om een nieuw wachtwoord te kiezen.'
    },
    introduction: {
      title: 'Introductie',
      text: 'In Greenmapper Friends kun je <b>natuur- of landschapsplekken markeren </b> die je <b>aantrekkelijk, waardevol of belangrijk</b> vindt. Deze gebieden moeten plekken met groen, water of natuur zijn. Je kunt denken aan een plek in een park, bij een meer, op zee, in een bos, een grasland, een bloemenveld of een plek om vogels te spotten. Het kan een plek zijn binnen of buiten een stad of dorp, klein of groot. Je kunt deze plek vaak bezoeken, of misschien bijna nooit! Het gaat er om dat het de natuurplek voor jou aantrekkelijk, waardevol of betekenisvol is.',
      start_btn: 'Start enquête'
    },
    register: {
      email_sublabel: 'niet zichtbaar voor anderen',
      name_sublabel: 'zichtbaar voor anderen',
      name_hint: 'bijvoorbeeld een bijnaam of voornaam',
      address_search_sublabel: '±200 m is genoeg',
      password_hint: 'minimaal 8 karakters',
      map_preview_hint: 'Selecteer een woonlocatie om deze op de kaart te zien',
      use_my_location: 'Gebruik mijn locatie',
      geolocate_failed: 'Kon je locatie niet bepalen. Controleer de rechten of zoek handmatig.',
      location_not_found: 'Geen locatie gevonden. Probeer een plaats, adres of postcode.',
      disclaimer_title: 'Disclaimer Greenmapper Friends',
      disclaimer: 'Greenmapper Friends slaat je e-mailadres op in het Greenmapper Landscape Friend Registry (GLFR). Niemand heeft toegang tot dit e-mailadres behalve Greenmapper Friends. Via het GLFR kun je anoniem worden benaderd door landeigenaren, landbeheerorganisaties of andere vrienden van het gebied. Deze derden hebben echter geen directe toegang tot je e-mailadres of persoonlijke gegevens. We vragen ook om je thuislocatie. Dit is een locatie bij benadering: het gaat om de straat of buurt waar je woont. Je geeft dit aan op de kaart; je precieze adres is niet nodig! We volgen de richtlijnen van de Europese Algemene Verordening Gegevensbescherming (AVG) voor privacy en het opslaan van je persoonlijke gegevens. Lees meer details'
    },
    info_contact: {
      title: 'Over ons',
      contact: 'Contact',
      disclaimer_title: 'Disclaimer',
      implementation: 'Implementatie: '
    },
    map: {
      title: 'Algemene community kaart',
      add_btn: 'Teken een nieuw gebied',
      share_title: 'Deel kaart url',
      share_btn: 'Kopieer naar klembord',
      hint_on_add: 'Plaats de stip op de kaart om te starten met tekenen',
      hint_on_end_draw: 'Je kunt het gebied nog steeds aanpassen.',
      zoom_to_area_btn: 'Zoom in naar het gebied',
      details_btn: 'Bekijk details',
      menu_btn: 'Kaartopties',
      layers_btn: 'Kaart of satelliet',
      gps_btn: 'Naar mijn locatie',
      home_btn: 'Naar mijn thuis' // share_desc: 'Share'

    },
    timeline: {
      title: 'Tijdlijn',
      rating: 'Waardering',
      rating_subtext: 'Persoonlijke waardering van het gemarkeerde gebied',
      visit_frequency: 'Bezoekfrequentie',
      visit_frequency_subtext: 'Hoe vaak bezoek je het gebied?',
      activities: 'Activiteiten',
      activities_subtext: 'Activiteiten gemeld bij gemarkeerde gebied',
      add_btn: 'Voeg gebied toe',
      edit_btn: 'Pas gebied aan',
      delete_btn: 'Verwijder gebied',
      delete_title: 'Verwijder gebied',
      delete_subtitle: 'Weet je het zeker?'
    },
    add_area_info: {
      title: 'Voeg een gebied toe',
      add_btn: 'Voeg gebied toe'
    },
    my_areas: {
      open_btn: 'Toon in Google Maps',
      title: 'Mijn gebieden',
      sub_title: 'Alle natuurlijke plekken die ik aantrekkelijk, waardevol of belangrijk vind.',
      created_areas: 'Gemarkeerde gebieden',
      joint_surface: 'Totaal oppervlak (km2)',
      and_section_eyebrow: 'Greenmapper Database Aantrekkelijke Natuur',
      and_section_title: 'Je vier favoriete plekken op schaal',
      and_complete_badge: 'Alle vier schalen compleet',
      free_section_title: 'Plekken die je zelf hebt toegevoegd'
    },
    my_communities: {
      open_btn: 'Community openen',
      title: 'Mijn communities',
      sub_title: 'Alle gebieden van landeigenaren of landbeheerders die overlappen met mijn gebieden. Hier ben je bereikbaar als vriend van die gebieden.',
      delete_btn: 'Afmelden',
      delete_title: 'Afmelden',
      delete_subtitle: 'Weet je zeker dat je je wilt afmelden voor deze community?',
      befriended_communities: 'Bevriende communities',
      joint_surface: 'Totaal oppervlak (km2)'
    },
    info: {
      text1: 'Greenmapper Friends wordt ontwikkeld door Greenmapper. Voor meer informatie kijk op Greenmapper.org',
      text2: 'Als je vragen hebt of in contact wilt komen met ons, stuur dan een e-mail naar: info@greenmapper.org',
      text3: 'We proberen de Greenmapper Friends applicatie en data accuraat en vrij van fouten te houden. Als je -ondanks onze inspanningen- incomplete of inacurate informatie tegenkomt, dan kunnen we daar geen verantwoordelijkheid voor nemen.',
      text4: 'We houden het recht voor om aanpassingen, het verwijderen of toevoegen van materiaal aan de inhoud van de applicatie te doen zonder waarschuwing vooraf. Greenmapper Friends accepteert geen aansprakelijkheid voor informatie op websites waarnaar wij verwijzen via hyperlinks.'
    },
    my_owned_communities: {
      title: 'Mijn communities',
      owned_communities: 'Communities',
      total_subs: 'Totaal aantal leden',
      joint_surface: 'Totaal oppervlak (km2)'
    },
    community: {
      report_title: 'Melden commentaar',
      report_subtitle: 'Weet je zeker dat je dit commentaar wilt melden voor moderatie?',
      report_hint: 'Geef een reden',
      delete_title: 'Verwijder commentaar',
      delete_subtitle: 'Weet je zeker dat je dit commentaar wilt verwijderen?',
      discussions_title: 'Discussies',
      discussions_subtitle: 'Open discussies over elk onderwerp',
      poll_title: 'Poll',
      poll_subtitle: 'Simpele opiniepeiling',
      polis_title: 'Pol.is',
      polis_subtitle: 'Klik op het onderstaande onderwerp om pol.is-peiling te starten',
      pledges_title: 'Steun projecten!',
      pledges_subtitle: 'Virtuele toezegging van geld voor biodiversiteit, landschapskwaliteit of duurzame diensten',
      meetings_title: 'Meetings',
      meetings_subtitle: 'Diepgaande online workshop of vergadering van vrienden',
      RMS_dialog_title: 'Verzoek moderator status',
      RMS_dialog_text: 'Wil je een verzoek versturen om moderator voor deze community te worden?',
      more_btn: 'Meer opties',
      to_map_btn: 'Toon op de kaart',
      treasures_title: 'Treasures',
      show_report_btn: 'Toon melding',
      join_btn: 'Word lid'
    },
    poll: {
      deleted: 'De peiling is verwijderd',
      label: 'Peiling',
      delete_title: 'Peiling verwijderen',
      delete_text: 'Weet je zeker dat je deze peiling en de stemmen wilt verwijderen?',
      votes: 'stemmen',
      voted: 'Je hebt gestemd'
    },
    polis: {
      deleted: 'Het Polis-gesprek is verwijderd',
      delete_title: 'Polis-gesprek verwijderen',
      delete_text: 'Weet je zeker dat je dit Polis-gesprek uit de community wilt verwijderen?',
      text: 'Voor elke stelling kun je ‘Akkoord’, ‘Niet akkoord’, of ‘Onzeker’ stemmen.',
      text2: 'Stuur jouw mening in, zodat anderen op jouw idee kunnen stemmen.'
    },
    account: {
      edit_title: 'Pas profiel aan',
      saved: 'Profiel opgeslagen',
      signout_title: 'Log uit'
    },
    create_area: {
      title: 'Gebied aanmaken',
      add_title: 'Gebied toevoegen',
      home_title: 'Plaats thuis marker',
      pauze_title: 'Weet je het zeker?',
      pauze_text: 'Pauzeer registratie en maak later af',
      map_tips: 'Kaarttips',
      search_place: 'Zoek een plek',
      search_not_found: 'Niets gevonden',
      zoom_smaller: 'Kleiner',
      zoom_bigger: 'Groter',
      area_reset: 'Gebied gereset',
      reset_polygon: 'Polygoon resetten',
      reset_polygon_title: 'Polygoon resetten?',
      reset_polygon_text: 'Hiermee zet je de polygoon terug naar hoe deze eruitzag voordat je ging bewerken.',
      leave_polygon_edit_title: 'Polygoonbewerkingen verlaten?',
      leave_polygon_edit_text: 'Als je teruggaat, wordt de polygoon weer de cirkelselectie. Je puntbewerkingen gaan verloren.',
      polygon_guard: {
        cross: 'Lijnen mogen elkaar niet kruisen',
        spacing: 'Punten mogen niet te dicht bij elkaar',
        edge: 'Punt mag niet te dicht bij een andere zijde',
        angle: 'Hoek mag niet zo scherp worden',
        area: 'Gebied mag niet zo klein worden',
        bounds: 'Punt blijft binnen het zichtbare kaartgebied',
        too_few: 'Gebied heeft minstens 3 punten nodig',
        not_closed: 'Vorm is niet gesloten',
        duplicate: 'Twee punten liggen op dezelfde plek',
        range: 'Punt ligt buiten het geldige kaartgebied',
        invalid: 'Deze vorm kan niet worden opgeslagen'
      },
      loading: {
        title: 'Kaart voorbereiden',
        opening: 'Kaart openen…',
        loading_account: 'Account laden…',
        loading_areas: 'Jouw gebieden laden…',
        loading_home: 'Woonplek laden…'
      },
      hints: {
        place_above_area: 'Plaats over je gebied',
        place_area_here: 'Plek volledig erin',
        drag_vertex: 'Sleep punten voor betere pasvorm',
        zoom: 'Zoom in en uit',
        at_edge: 'Je hebt de rand van dit gebied bereikt'
      },
      stepper: {
        description: 'Omschrijving',
        rate: 'Beoordeling',
        visit_freq: 'Bezoekfrequentie',
        activities: 'Activiteiten',
        connected: 'Online verbonden'
      },
      steps: {
        level: {
          nav_title: 'Niveau',
          title: 'Kies niveau',
          task_title: 'Kies niveau van het gebied',
          options: {
            neighborhood: 'buurt / lokaal',
            living_area: 'regio / regionaal',
            country: 'land',
            world: 'wereld'
          }
        },
        map: {
          nav_title: 'Kaart',
          title: 'Teken gebied',
          task_title: 'Teken je gebied'
        },
        description: {
          nav_title: 'Omschrijving',
          title: 'Omschrijving',
          task_title: 'Hoe noem jij dit gebied?',
          input_title: 'Titel',
          input_name: 'Naam',
          input_title_error: 'Maximaal {max} karakters',
          input_description: 'Omschrijving',
          task_description: 'Waarom is dit gebied aantrekkelijk, waardevol en/of belangrijk?',
          input_description_error: 'Maximaal {max} karakters'
        },
        rate: {
          nav_title: 'Beoordeling',
          title: 'Waardeer je gebied',
          task_title: '(Score: 1 = slecht, 6 = gemiddeld, 10 = perfect)'
        },
        visit_freq: {
          nav_title: 'Bezoekfrequentie',
          title: 'Hoe vaak bezoek je jouw gebied?',
          options: {
            daily: 'Dagelijks',
            weekly: 'Wekelijks',
            monthly: 'Maandelijks',
            few_times_a_year: 'Paar keer per jaar',
            yearly: 'Jaarlijks',
            rarely: 'Soms',
            never: 'Nooit'
          }
        },
        activities: {
          nav_title: 'Activiteiten',
          title: 'Welke activiteiten doe je zoal in dit gebied?'
        },
        priority: {
          nav_title: 'Prioriteit',
          title: 'Deze plek zou moeten worden:',
          options: {
            maintained: 'Behouden (= zo laten als het is)',
            strengthened: 'Versterkt (= verbeteren)'
          }
        },
        relationship: {
          nav_title: 'Relatie',
          title: 'Wat is je relatie met dit favoriete natuurgebied?',
          options: {
            tourist: 'Toerist',
            inhabitant: 'Inwoner',
            work: 'Werkgerelateerd'
          }
        },

        /* finished: {
            '1_title': 'Dank je! Je eerste plek staat op de kaart',
            '1_text': 'Alleen al deze bijdrage helpt beter begrijpen welke natuurgebieden mensen waarderen. Je kunt nu een volgende plek toevoegen, of later terugkomen (via de knop rechtsboven).',
            '2_title': 'Mooi — je persoonlijke kaart begint vorm te krijgen',
            '2_text': 'Met elke plek help je beter zichtbaar maken wat bescherming verdient. Je kunt nu een volgende plek toevoegen, of later terugkomen (via de knop rechtsboven)',
            '3_title': 'Dank je! Je bijdrage geeft nu al waardevolle inzichten voor natuur en landschap',
            '3_text': 'Nog één plek toevoegen maakt je kaart compleet — maar je kunt ook later verdergaan (via de knop rechtsboven)',
            '4_title': 'Geweldig — je persoonlijke kaart is compleet!',
            '4_text': 'Je bijdrage helpt onderzoekers en beheerders beter begrijpen welke plekken mensen willen behouden en beschermen. We gaan nu bijna het overzicht van je plekken zien. Eerst nog een vraag over mogelijke financiële steun aan je gebieden.'
        } */
        finished: {
          '1_title': 'Dank je! Je eerste plek staat op de kaart',
          '1_text': 'Alleen al deze bijdrage helpt beter begrijpen welke natuurgebieden mensen waarderen.',
          '2_title': 'Mooi — je persoonlijke kaart begint vorm te krijgen',
          '2_text': 'Met elke plek help je beter zichtbaar maken wat bescherming verdient.',
          '3_title': 'Dank je! Je bijdrage geeft nu al waardevolle inzichten voor natuur en landschap',
          '3_text': 'Nog één plek toevoegen maakt je kaart compleet.',
          '4_title': 'Geweldig — je persoonlijke kaart is compleet!',
          '4_text': 'Je bijdrage helpt onderzoekers en beheerders beter begrijpen welke plekken mensen willen behouden en beschermen. We gaan nu bijna het overzicht van je plekken zien. Eerst nog een vraag over mogelijke financiële steun aan je gebieden.'
        }
      },
      _edit: {
        title: 'Pas gebied aan'
      },
      welcome: {
        title: 'Gebieden tekenen en vragen beantwoorden',
        subtitle: 'Markeer vier natuurplekken op verschillende schalen en vertel waarom ze belangrijk voor je zijn.',
        sheet_text: 'Bekijk hieronder het overzicht. Druk op Volgende om je eerste gebied te tekenen in de buurt.',
        how_it_works_title: 'Wat je per niveau doet',
        step_draw: 'Markeer een gebied op de kaart',
        step_questions: 'Beantwoord vragen over je plek',
        step_next_level: 'Herhaal voor 4 schalen',
        journey_title: 'Vier schalen, vier plekken',
        video_caption: 'Korte uitleg over het tekenen van een gebied'
      },
      welcome_v3: {
        greeting: 'Welkom bij Greenmapper Friends',
        title: 'Markeer je natuurplek',
        intro: 'Markeer plekken met groen, water of landschap die je aantrekkelijk, waardevol of belangrijk vindt.',
        levels_title: 'Vier schalen',
        levels_intro: 'Op elk niveau kies je één plek.',
        checklist_title: 'Wat je per niveau doet',
        step_draw: 'Teken de plek als een gebied op de kaart.',
        step_adjust: 'Pas de vorm aan en bevestig het gebied.',
        step_questions: 'Beantwoord enkele vragen over waarom deze plek belangrijk voor je is.',
        step_repeat: 'Herhaal deze stappen voor het volgende schaalniveau.',
        repeat_hint: 'Je begint in je buurt. Na de vragen ga je door naar regio, land en wereld.',
        start_btn: 'Start met Buurt'
      },
      welcome_v4: {
        title: 'Markeer je natuurplek',
        title_next: 'Volgende plek: {level}',
        intro: 'Markeer plekken met groen, water of landschap die je aantrekkelijk, waardevol of belangrijk vindt.',
        intro_next: 'Ga verder met {level}. Markeer een plek met groen, water of landschap die je aantrekkelijk, waardevol of belangrijk vindt.',
        checklist_title: 'Wat je per niveau doet',
        start_badge: 'Start',
        now_badge: 'Nu',
        done_badge: 'Klaar',
        progress: 'Plek {current} van 4',
        start_btn: 'Start met {level}',
        continue_btn: 'Ga verder met {level}'
      }
    },
    edit_area: {
      title: 'Pas gebied aan'
    },
    funding: {
      not_eligible: 'Helaas kun je niet meedoen aan de financieringsvragenlijst: die vraagt naar minstens twee eigen gebieden.',
      title: 'Virtuele Natuur- en Gemeenschapsfondsen',
      // the wizard's bar (the whole name was cut off, the user's review of #493)
      title_nav: 'Natuurfonds',
      nav_intro: 'Introductie',
      nav_amount: 'Hoeveelheid',
      nav_locations: 'Locaties',
      nav_objectives: 'Doeleinden',
      nav_finalize: 'Einde',
      intro1: 'Hallo!',
      intro2: 'Dank je wel voor je deelname aan het Greenmapper-experiment over natuurfinanciering.',
      intro3: 'In dit onderdeel gebruik je het <b>Virtueel Natuur- en Gemeenschapsfonds</b>. Je laat zien hoe je een <b>denkbeeldig</b> jaarlijks natuurbudget zou verdelen — <b>zonder echt te betalen</b>. Samen met andere deelnemers geeft dit beheerders en beleidsmakers inzicht in wat mensen belangrijk vinden.',
      intro4: '<h6>Hoe het werkt in 3 stappen:</h6>',
      step1: 'Bevestig je totale natuurbudget',
      step2: 'Verdeel over je 4 gebieden',
      step3: 'Verdeel per gebied over doelen: biodiversiteit, landschap, duurzaam ondernemen, cultuur en anders',
      caption: 'Stam = gebied • Takken = doelen • Appels = voorbeelden van projecten.',
      intro5: '<b>Praktisch</b>: 5–8 min • anoniem • geen goede/foute antwoorden.',
      intro6: 'Als dank <b>doneren wij €5 aan natuur op Texel</b> na afronding van dit onderdeel.',
      amount1: 'Virtueel financieringsbedrag',
      amount2: 'Wat zou jij — als het echt kon — per jaar willen besteden aan jouw favoriete natuurgebieden? Het gaat om een fictief bedrag, maar probeer een keuze te maken die voor jou realistisch aanvoelt.',
      amount3: 'Vul hieronder je (virtuele) jaarlijkse natuurbudget in.',
      amount4: 'Kun je kort toelichten waarom je voor dit bedrag hebt gekozen? Bijvoorbeeld wat je belangrijk vindt om te steunen, of hoe je dit bedrag hebt bepaald.',
      amount5: 'jaarlijks budget',
      max: 'Maximun bedrag 5000 euro',
      min: 'Minimun bedrag 1 euro',
      locations1: 'Verdeel je budget over je favoriete natuurgebieden',
      locations2: 'Geef aan hoe jij je gekozen (virtuele) budget zou verdelen over de Virtuele Natuur- en Gemeenschapsfondsen van jouw favoriete natuurgebieden.',
      locations3: 'Kun je kort toelichten hoe je jouw verdeling hebt gemaakt? Waarom heb je ervoor gekozen om het zo te verdelen?',
      objectives1: 'Budget verdeling over de financieringsdoeleinden',
      objectives2: 'Hier zie je jouw verdeling over de Virtuele Natuur- en Gemeenschapsfondsen voor jouw gekozen gebied. Je kunt dit doen voor je favoriete gebieden in jouw buurt, regio, land en wereldwijd. Geef aan hoe jij je budget zou verdelen over de vier doelen:',
      objectives2a: 'Wil je iets steunen dat niet binnen deze categorieën past? Schrijf dat dan onderaan bij ‘Anders namelijk...’ en geef er een deel van je budget aan.',
      objectives3: 'Kun je kort toelichten hoe je jouw verdeling hebt gemaakt? Waarom heb je ervoor gekozen om het zo te verdelen?',
      biodiversity_title: 'Behoud van biodiversiteit',
      biodiversity_text: 'Een rijke biodiversiteit ondersteunt het functioneren van ecosystemen en is cruciaal voor het ondersteunen van al het leven op aarde. Projecten voor biodiversiteitsbehoud hebben als doel om de biodiversiteitswaarden te verbeteren of te behouden, vaak in een lokale context. Dergelijke projecten kunnen gericht zijn op het verbeteren van de bodem- en waterkwaliteit of bijvoorbeeld het plaatsen van nestkasten voor vogels.',
      ALC_title: 'Landschapskwaliteit en uitzicht',
      ALC_text: 'Een aantrekkelijk landschapsaangezicht heeft betrekking op het uitzicht en het genieten van een landschap. Een dergelijk project kan gaan over het beschermen of herstellen van landschapselementen zoals heggen, het opnieuw ‘verwilderen’ van het landschap of het aanleggen van wandel- of fietsroutes door het landschap.',
      SUSBUS_title: 'Duurzaam ondernemen',
      SUSBUS_text: 'Duurzame bedrijven voeren hun economische activiteiten uit zonder negatieve effecten voor hun (lokale) omgeving te veroorzaken. Duurzame bedrijfsprojecten kunnen betrekking hebben op de overgang van een conventionele boerderij naar biologische of natuurinclusieve landbouw. Het kan ook verwijzen naar het stichten van een netwerk van lokale bedrijven en organisaties die op geïntegreerde wijze afval en vervuiling verminderen.',
      finalize1: '<b>Bedankt!</b><br> Dank je voor je deelname aan het onderzoek naar natuurfinanciering van de Rijksuniversiteit Groningen. Je antwoorden zijn waardevol. Klik op <b>Opslaan</b> om ze vast te leggen.',
      finalize1A: '<b>Hoera!!</b><br> Je hebt €10,- verdiend voor natuurprojecten op Texel. Dank je — jouw bijdrage helpt ons begrijpen hoe mensen natuur willen steunen.',
      finalize1B: '<b>Wat gebeurt er nu?</b><br> Je gaat naar de Greenmapper Friends-community ‘Nationaal Park Duinen van Texel’ voor deel 3. Daar beoordeel je zes echte financieringsverzoeken. Geef per project aan of je het steunt en waarom.\n' + 'Je eigen bijdrage is fictief, maar de donaties van €10,- en €5,- namens jou zijn echt.',
      finalize1C: '<b>Extra beloning voor Texel</b><br> Reageer je op alle zes verzoeken? Dan doneert Greenmapper nog eens €5,- extra. Elke reactie telt! Na het reageren op alle zes verzoeken loot je automatisch mee om de prijs.',
      finalize2: 'In de volgende sectie zie je alle pledges staan . Je moet op elke pledge drukken en aangeven of je wilt pledgen ja of nee. En daarna de volgende pledge selecteren ',
      cultural_title: 'Cultuur en gemeenschapsleven',
      cultural_text: 'Natuurgebieden kunnen ook een cultureel erfgoed of andere culturele aspecten bevatten. Bijvoorbeeld als er historische gebouwen of monumenten aanwezig zijn, of als er bepaalde culturele evenementen mee verbonden zijn. Culturele projecten hebben betrekking tot de organisatie van (muzikale) evenementen, educatieve excursies of het behoud van landgoederen.',
      other_title: 'Anders',
      other_text: 'Wil je iets anders financieren in je favoriete natuurgebied, maar werd dit hierboven niet genoemd? Beschrijf het dan zelf! Je kunt deze schuifregelaar gebruiken om aan te geven hoeveel van je budget je eraan wilt toewijzen. Dit is niet verplicht, alleen als je denkt aan iets dat niet binnen de eerder genoemde financieringsdoelen valt.',
      placeholder: 'Anders namelijk..'
    }
  },
  drawer: {
    area_section: 'Ontdekken',
    my_section: 'Mijn overzicht',
    other_section: 'Anders',
    edit_funding: 'Mijn Natuurbudget',
    per_year: '/jaar',
    messages: 'Berichten'
  },
  mail: {
    to: 'Aan',
    none: 'Nog geen berichten',
    from: 'Van',
    subject: 'Titel',
    date: 'Datum',
    inbox: 'Inbox',
    outbox: 'Outbox',
    compose: 'Opstellen'
  },
  gender: {
    male: 'man',
    female: 'vrouw',
    other: 'anders'
  },
  education: {
    1: 'Basisonderwijs',
    2: 'Middelbaar onderwijs',
    3: 'Opleiding zonder diploma',
    4: 'MBO',
    5: 'HBO',
    6: 'Universitaire Bachelor',
    7: 'Universitaire Master',
    8: 'Doctoraat'
  },
  video: {
    'draw_popup_title_1': 'Buurt',
    'draw_popup_subtitle_1': 'Binnen 2km van huis',
    'draw_popup_text_1': 'Deze kaart laat een gebied van 2km rondom je woonplek zien. Markeer een natuur-gerelateerde plek binnen deze 2km, die voor jou aantrekkelijk, waardevol of belangrijk is. Weet je geen plek binnen de 2km cirkel, markeer dan een gebied zo dicht mogelijk erbij.',
    'draw_popup_title_2': 'Regio',
    'draw_popup_subtitle_2': 'Binnen 20km van huis',
    'draw_popup_text_2': 'Deze kaart laat een gebied van 20km rondom je woonplek zien. Markeer een natuur-gerelateerde plek binnen deze 20km die voor jou aantrekkelijk, waardevol en belangrijk is.',
    'draw_popup_title_3': 'Land',
    'draw_popup_subtitle_3': 'Heel het land',
    'draw_popup_text_3': 'Deze kaart laat een kaart van Nederland zien. Markeer een natuur-gerelateerde plek op deze kaart die voor jou aantrekkelijk, waardevol of belangrijk is.',
    'draw_popup_title_4': 'Wereld',
    'draw_popup_subtitle_4': 'Wereldwijd',
    'draw_popup_text_4': 'Deze kaart laat een kaart van de wereld zien. Markeer een natuur-gerelateerde plek op deze kaart die voor jou aantrekkelijk, waardevol of belangrijk is. Weet je geen plekken ver weg, dan kun je hier ook nóg een plek in je eigen land markeren.',
    'draw_popup_video': 'Hieronder zie je een korte video (30s) over hoe je een gebied tekent.',
    'area_size': 'Gebied: {width} km breed, {area} km{squared}',
    'step1_helper': 'Sleep de kaart zodat jouw aantrekkelijke plek helemaal in de heldere cirkel past. Zoom tot de cirkel de plek volledig dekt.',
    'step2_helper': 'Ziet het er goed uit? Ga verder — of sleep optioneel de punten zodat de vorm je plek beter dekt.',
    'clamp_hint_default': 'Dit blijft binnen {distance}. Bij de volgende vraag mag het verder.',
    'scale_badge_radius': 'Binnen {distance} van thuis',
    'scale_badge_full': 'Op de kaart van {name}',
    'level_up_toast': 'Gebied vergroot naar {distance}'
  }
};